'use strict';

/*!
 * Tabler v1.0.0-beta3 (https://tabler.io)
 * @version 1.0.0-beta3
 * @link https://tabler.io
 * Copyright 2018-2021 The Tabler Authors
 * Copyright 2018-2021 codecalm.net PaweĹ‚ Kuna
 * Licensed under MIT (https://github.com/tabler/tabler/blob/master/LICENSE)
 */
!(function(t) {
  'function' == typeof define && define.amd ? define(t) : t();
})(function() {
  'use strict';

  'undefined' != typeof globalThis
    ? globalThis
    : 'undefined' != typeof window
    ? window
    : 'undefined' != typeof global
    ? global
    : 'undefined' != typeof self && self;
  var t = {
    exports: {},
  };
  !(function(t, e) {
    var n,
      i,
      s =
        'function' == typeof Map
          ? new Map()
          : ((n = []),
            (i = []),
            {
              has: function(t) {
                return n.indexOf(t) > -1;
              },
              get: function(t) {
                return i[n.indexOf(t)];
              },
              set: function(t, e) {
                -1 === n.indexOf(t) && (n.push(t), i.push(e));
              },
              delete: function(t) {
                var e = n.indexOf(t);
                e > -1 && (n.splice(e, 1), i.splice(e, 1));
              },
            }),
      r = function(t) {
        return new Event(t, {
          bubbles: !0,
        });
      };

    try {
      new Event('test');
    } catch (t) {
      r = function(t) {
        var e = document.createEvent('Event');
        return e.initEvent(t, !0, !1), e;
      };
    }

    function o(t) {
      if (t && t.nodeName && 'TEXTAREA' === t.nodeName && !s.has(t)) {
        var e = null,
          n = null,
          i = null,
          o = function() {
            t.clientWidth !== n && h();
          },
          a = function(e) {
            window.removeEventListener('resize', o, !1),
              t.removeEventListener('input', h, !1),
              t.removeEventListener('keyup', h, !1),
              t.removeEventListener('autosize:destroy', a, !1),
              t.removeEventListener('autosize:update', h, !1),
              Object.keys(e).forEach(function(n) {
                t.style[n] = e[n];
              }),
              s.delete(t);
          }.bind(t, {
            height: t.style.height,
            resize: t.style.resize,
            overflowY: t.style.overflowY,
            overflowX: t.style.overflowX,
            wordWrap: t.style.wordWrap,
          });

        t.addEventListener('autosize:destroy', a, !1),
          'onpropertychange' in t && 'oninput' in t && t.addEventListener('keyup', h, !1),
          window.addEventListener('resize', o, !1),
          t.addEventListener('input', h, !1),
          t.addEventListener('autosize:update', h, !1),
          (t.style.overflowX = 'hidden'),
          (t.style.wordWrap = 'break-word'),
          s.set(t, {
            destroy: a,
            update: h,
          }),
          'vertical' === (u = window.getComputedStyle(t, null)).resize
            ? (t.style.resize = 'none')
            : 'both' === u.resize && (t.style.resize = 'horizontal'),
          (e =
            'content-box' === u.boxSizing
              ? -(parseFloat(u.paddingTop) + parseFloat(u.paddingBottom))
              : parseFloat(u.borderTopWidth) + parseFloat(u.borderBottomWidth)),
          isNaN(e) && (e = 0),
          h();
      }

      var u;

      function l(e) {
        var n = t.style.width;
        (t.style.width = '0px'), t.offsetWidth, (t.style.width = n), (t.style.overflowY = e);
      }

      function c() {
        if (0 !== t.scrollHeight) {
          var i = (function(t) {
              for (var e = []; t && t.parentNode && t.parentNode instanceof Element; )
                t.parentNode.scrollTop &&
                  e.push({
                    node: t.parentNode,
                    scrollTop: t.parentNode.scrollTop,
                  }),
                  (t = t.parentNode);

              return e;
            })(t),
            s = document.documentElement && document.documentElement.scrollTop;

          (t.style.height = ''),
            (t.style.height = t.scrollHeight + e + 'px'),
            (n = t.clientWidth),
            i.forEach(function(t) {
              t.node.scrollTop = t.scrollTop;
            }),
            s && (document.documentElement.scrollTop = s);
        }
      }

      function h() {
        c();
        var e = Math.round(parseFloat(t.style.height)),
          n = window.getComputedStyle(t, null),
          s = 'content-box' === n.boxSizing ? Math.round(parseFloat(n.height)) : t.offsetHeight;

        if (
          (s < e
            ? 'hidden' === n.overflowY &&
              (l('scroll'),
              c(),
              (s =
                'content-box' === n.boxSizing
                  ? Math.round(parseFloat(window.getComputedStyle(t, null).height))
                  : t.offsetHeight))
            : 'hidden' !== n.overflowY &&
              (l('hidden'),
              c(),
              (s =
                'content-box' === n.boxSizing
                  ? Math.round(parseFloat(window.getComputedStyle(t, null).height))
                  : t.offsetHeight)),
          i !== s)
        ) {
          i = s;
          var o = r('autosize:resized');

          try {
            t.dispatchEvent(o);
          } catch (t) {}
        }
      }
    }

    function a(t) {
      var e = s.get(t);
      e && e.destroy();
    }

    function u(t) {
      var e = s.get(t);
      e && e.update();
    }

    var l = null;
    'undefined' == typeof window || 'function' != typeof window.getComputedStyle
      ? (((l = function(t) {
          return t;
        }).destroy = function(t) {
          return t;
        }),
        (l.update = function(t) {
          return t;
        }))
      : (((l = function(t, e) {
          return (
            t &&
              Array.prototype.forEach.call(t.length ? t : [t], function(t) {
                return o(t);
              }),
            t
          );
        }).destroy = function(t) {
          return t && Array.prototype.forEach.call(t.length ? t : [t], a), t;
        }),
        (l.update = function(t) {
          return t && Array.prototype.forEach.call(t.length ? t : [t], u), t;
        })),
      (e.default = l),
      (t.exports = e.default);
  })(t, t.exports);
  var e = t.exports,
    n = document.querySelectorAll('[data-bs-toggle="autosize"]');

  function i(t) {
    return (i =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function(t) {
            return typeof t;
          }
        : function(t) {
            return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype
              ? 'symbol'
              : typeof t;
          })(t);
  }

  function s(t, e) {
    if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
  }

  function r(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      (i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        'value' in i && (i.writable = !0),
        Object.defineProperty(t, i.key, i);
    }
  }

  function o(t, e, n) {
    return e && r(t.prototype, e), n && r(t, n), t;
  }

  function a(t, e) {
    if ('function' != typeof e && null !== e) throw new TypeError('Super expression must either be null or a function');
    (t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0,
      },
    })),
      e && l(t, e);
  }

  function u(t) {
    return (u = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function(t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
  }

  function l(t, e) {
    return (l =
      Object.setPrototypeOf ||
      function(t, e) {
        return (t.__proto__ = e), t;
      })(t, e);
  }

  function c(t, e) {
    if (null == t) return {};

    var n,
      i,
      s = (function(t, e) {
        if (null == t) return {};
        var n,
          i,
          s = {},
          r = Object.keys(t);

        for (i = 0; i < r.length; i++) (n = r[i]), e.indexOf(n) >= 0 || (s[n] = t[n]);

        return s;
      })(t, e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);

      for (i = 0; i < r.length; i++)
        (n = r[i]), e.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(t, n) && (s[n] = t[n]));
    }

    return s;
  }

  function h(t, e) {
    return !e || ('object' != typeof e && 'function' != typeof e)
      ? (function(t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        })(t)
      : e;
  }

  function d(t) {
    var e = (function() {
      if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ('function' == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
      } catch (t) {
        return !1;
      }
    })();

    return function() {
      var n,
        i = u(t);

      if (e) {
        var s = u(this).constructor;
        n = Reflect.construct(i, arguments, s);
      } else n = i.apply(this, arguments);

      return h(this, n);
    };
  }

  function f(t, e) {
    for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = u(t)); );

    return t;
  }

  function p(t, e, n) {
    return (p =
      'undefined' != typeof Reflect && Reflect.get
        ? Reflect.get
        : function(t, e, n) {
            var i = f(t, e);

            if (i) {
              var s = Object.getOwnPropertyDescriptor(i, e);
              return s.get ? s.get.call(n) : s.value;
            }
          })(t, e, n || t);
  }

  function g(t, e, n, i) {
    return (g =
      'undefined' != typeof Reflect && Reflect.set
        ? Reflect.set
        : function(t, e, n, i) {
            var s,
              r = f(t, e);

            if (r) {
              if ((s = Object.getOwnPropertyDescriptor(r, e)).set) return s.set.call(i, n), !0;
              if (!s.writable) return !1;
            }

            if ((s = Object.getOwnPropertyDescriptor(i, e))) {
              if (!s.writable) return !1;
              (s.value = n), Object.defineProperty(i, e, s);
            } else
              !(function(t, e, n) {
                e in t
                  ? Object.defineProperty(t, e, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (t[e] = n);
              })(i, e, n);

            return !0;
          })(t, e, n, i);
  }

  function m(t, e, n, i, s) {
    if (!g(t, e, n, i || t) && s) throw new Error('failed to set property');
    return n;
  }

  function v(t, e) {
    return (
      (function(t) {
        if (Array.isArray(t)) return t;
      })(t) ||
      (function(t, e) {
        if ('undefined' == typeof Symbol || !(Symbol.iterator in Object(t))) return;
        var n = [],
          i = !0,
          s = !1,
          r = void 0;

        try {
          for (
            var o, a = t[Symbol.iterator]();
            !(i = (o = a.next()).done) && (n.push(o.value), !e || n.length !== e);
            i = !0
          );
        } catch (t) {
          (s = !0), (r = t);
        } finally {
          try {
            i || null == a.return || a.return();
          } finally {
            if (s) throw r;
          }
        }

        return n;
      })(t, e) ||
      (function(t, e) {
        if (!t) return;
        if ('string' == typeof t) return _(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        'Object' === n && t.constructor && (n = t.constructor.name);
        if ('Map' === n || 'Set' === n) return Array.from(t);
        if ('Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _(t, e);
      })(t, e) ||
      (function() {
        throw new TypeError(
          'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
        );
      })()
    );
  }

  function _(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];

    return i;
  }

  function y(t) {
    return 'string' == typeof t || t instanceof String;
  }

  n.length &&
    n.forEach(function(t) {
      e(t);
    });
  var b = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT',
  };

  function k(t) {
    return t.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  var E = (function() {
      function t(e, n, i, r) {
        for (
          s(this, t), this.value = e, this.cursorPos = n, this.oldValue = i, this.oldSelection = r;
          this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos);

        )
          --this.oldSelection.start;
      }

      return (
        o(t, [
          {
            key: 'startChangePos',
            get: function() {
              return Math.min(this.cursorPos, this.oldSelection.start);
            },
          },
          {
            key: 'insertedCount',
            get: function() {
              return this.cursorPos - this.startChangePos;
            },
          },
          {
            key: 'inserted',
            get: function() {
              return this.value.substr(this.startChangePos, this.insertedCount);
            },
          },
          {
            key: 'removedCount',
            get: function() {
              return Math.max(
                this.oldSelection.end - this.startChangePos || this.oldValue.length - this.value.length,
                0
              );
            },
          },
          {
            key: 'removed',
            get: function() {
              return this.oldValue.substr(this.startChangePos, this.removedCount);
            },
          },
          {
            key: 'head',
            get: function() {
              return this.value.substring(0, this.startChangePos);
            },
          },
          {
            key: 'tail',
            get: function() {
              return this.value.substring(this.startChangePos + this.insertedCount);
            },
          },
          {
            key: 'removeDirection',
            get: function() {
              return !this.removedCount || this.insertedCount
                ? b.NONE
                : this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos
                ? b.RIGHT
                : b.LEFT;
            },
          },
        ]),
        t
      );
    })(),
    w = (function() {
      function t(e) {
        s(this, t),
          Object.assign(
            this,
            {
              inserted: '',
              rawInserted: '',
              skip: !1,
              tailShift: 0,
            },
            e
          );
      }

      return (
        o(t, [
          {
            key: 'aggregate',
            value: function(t) {
              return (
                (this.rawInserted += t.rawInserted),
                (this.skip = this.skip || t.skip),
                (this.inserted += t.inserted),
                (this.tailShift += t.tailShift),
                this
              );
            },
          },
          {
            key: 'offset',
            get: function() {
              return this.tailShift + this.inserted.length;
            },
          },
        ]),
        t
      );
    })(),
    A = (function() {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          i = arguments.length > 2 ? arguments[2] : void 0;
        s(this, t), (this.value = e), (this.from = n), (this.stop = i);
      }

      return (
        o(t, [
          {
            key: 'toString',
            value: function() {
              return this.value;
            },
          },
          {
            key: 'extend',
            value: function(t) {
              this.value += String(t);
            },
          },
          {
            key: 'appendTo',
            value: function(t) {
              return t
                .append(this.toString(), {
                  tail: !0,
                })
                .aggregate(t._appendPlaceholder());
            },
          },
          {
            key: 'state',
            get: function() {
              return {
                value: this.value,
                from: this.from,
                stop: this.stop,
              };
            },
            set: function(t) {
              Object.assign(this, t);
            },
          },
          {
            key: 'shiftBefore',
            value: function(t) {
              if (this.from >= t || !this.value.length) return '';
              var e = this.value[0];
              return (this.value = this.value.slice(1)), e;
            },
          },
        ]),
        t
      );
    })();

  function C(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return new C.InputMask(t, e);
  }

  var T = (function() {
    function t(e) {
      s(this, t), (this._value = ''), this._update(Object.assign({}, t.DEFAULTS, e)), (this.isInitialized = !0);
    }

    return (
      o(t, [
        {
          key: 'updateOptions',
          value: function(t) {
            Object.keys(t).length && this.withValueRefresh(this._update.bind(this, t));
          },
        },
        {
          key: '_update',
          value: function(t) {
            Object.assign(this, t);
          },
        },
        {
          key: 'state',
          get: function() {
            return {
              _value: this.value,
            };
          },
          set: function(t) {
            this._value = t._value;
          },
        },
        {
          key: 'reset',
          value: function() {
            this._value = '';
          },
        },
        {
          key: 'value',
          get: function() {
            return this._value;
          },
          set: function(t) {
            this.resolve(t);
          },
        },
        {
          key: 'resolve',
          value: function(t) {
            return (
              this.reset(),
              this.append(
                t,
                {
                  input: !0,
                },
                ''
              ),
              this.doCommit(),
              this.value
            );
          },
        },
        {
          key: 'unmaskedValue',
          get: function() {
            return this.value;
          },
          set: function(t) {
            this.reset(), this.append(t, {}, ''), this.doCommit();
          },
        },
        {
          key: 'typedValue',
          get: function() {
            return this.doParse(this.value);
          },
          set: function(t) {
            this.value = this.doFormat(t);
          },
        },
        {
          key: 'rawInputValue',
          get: function() {
            return this.extractInput(0, this.value.length, {
              raw: !0,
            });
          },
          set: function(t) {
            this.reset(),
              this.append(
                t,
                {
                  raw: !0,
                },
                ''
              ),
              this.doCommit();
          },
        },
        {
          key: 'isComplete',
          get: function() {
            return !0;
          },
        },
        {
          key: 'nearestInputPos',
          value: function(t, e) {
            return t;
          },
        },
        {
          key: 'extractInput',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length;
            return this.value.slice(t, e);
          },
        },
        {
          key: 'extractTail',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length;
            return new A(this.extractInput(t, e), t);
          },
        },
        {
          key: 'appendTail',
          value: function(t) {
            return y(t) && (t = new A(String(t))), t.appendTo(this);
          },
        },
        {
          key: '_appendCharRaw',
          value: function(t) {
            return t
              ? ((this._value += t),
                new w({
                  inserted: t,
                  rawInserted: t,
                }))
              : new w();
          },
        },
        {
          key: '_appendChar',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 ? arguments[2] : void 0,
              i = this.state,
              s = this._appendCharRaw(this.doPrepare(t, e), e);

            if (s.inserted) {
              var r,
                o = !1 !== this.doValidate(e);

              if (o && null != n) {
                var a = this.state;
                this.overwrite && ((r = n.state), n.shiftBefore(this.value.length));
                var u = this.appendTail(n);
                (o = u.rawInserted === n.toString()) && u.inserted && (this.state = a);
              }

              o || ((s = new w()), (this.state = i), n && r && (n.state = r));
            }

            return s;
          },
        },
        {
          key: '_appendPlaceholder',
          value: function() {
            return new w();
          },
        },
        {
          key: 'append',
          value: function(t, e, n) {
            if (!y(t)) throw new Error('value should be string');
            var i = new w(),
              s = y(n) ? new A(String(n)) : n;
            e && e.tail && (e._beforeTailState = this.state);

            for (var r = 0; r < t.length; ++r) i.aggregate(this._appendChar(t[r], e, s));

            return null != s && (i.tailShift += this.appendTail(s).tailShift), i;
          },
        },
        {
          key: 'remove',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length;
            return (this._value = this.value.slice(0, t) + this.value.slice(e)), new w();
          },
        },
        {
          key: 'withValueRefresh',
          value: function(t) {
            if (this._refreshing || !this.isInitialized) return t();
            this._refreshing = !0;
            var e = this.rawInputValue,
              n = this.value,
              i = t();
            return (
              (this.rawInputValue = e),
              this.value &&
                this.value !== n &&
                0 === n.indexOf(this.value) &&
                this.append(n.slice(this.value.length), {}, ''),
              delete this._refreshing,
              i
            );
          },
        },
        {
          key: 'runIsolated',
          value: function(t) {
            if (this._isolated || !this.isInitialized) return t(this);
            this._isolated = !0;
            var e = this.state,
              n = t(this);
            return (this.state = e), delete this._isolated, n;
          },
        },
        {
          key: 'doPrepare',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.prepare ? this.prepare(t, this, e) : t;
          },
        },
        {
          key: 'doValidate',
          value: function(t) {
            return (
              (!this.validate || this.validate(this.value, this, t)) && (!this.parent || this.parent.doValidate(t))
            );
          },
        },
        {
          key: 'doCommit',
          value: function() {
            this.commit && this.commit(this.value, this);
          },
        },
        {
          key: 'doFormat',
          value: function(t) {
            return this.format ? this.format(t, this) : t;
          },
        },
        {
          key: 'doParse',
          value: function(t) {
            return this.parse ? this.parse(t, this) : t;
          },
        },
        {
          key: 'splice',
          value: function(t, e, n, i) {
            var s = t + e,
              r = this.extractTail(s),
              o = this.nearestInputPos(t, i);
            return new w({
              tailShift: o - t,
            })
              .aggregate(this.remove(o))
              .aggregate(
                this.append(
                  n,
                  {
                    input: !0,
                  },
                  r
                )
              );
          },
        },
      ]),
      t
    );
  })();

  function S(t) {
    if (null == t) throw new Error('mask property should be defined');
    return t instanceof RegExp
      ? C.MaskedRegExp
      : y(t)
      ? C.MaskedPattern
      : t instanceof Date || t === Date
      ? C.MaskedDate
      : t instanceof Number || 'number' == typeof t || t === Number
      ? C.MaskedNumber
      : Array.isArray(t) || t === Array
      ? C.MaskedDynamic
      : C.Masked && t.prototype instanceof C.Masked
      ? t
      : t instanceof Function
      ? C.MaskedFunction
      : t instanceof C.Masked
      ? t.constructor
      : (console.warn('Mask not found for mask', t), C.Masked);
  }

  function D(t) {
    if (C.Masked && t instanceof C.Masked) return t;
    var e = (t = Object.assign({}, t)).mask;
    if (C.Masked && e instanceof C.Masked) return e;
    var n = S(e);
    if (!n)
      throw new Error(
        'Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.'
      );
    return new n(t);
  }

  (T.DEFAULTS = {
    format: function(t) {
      return t;
    },
    parse: function(t) {
      return t;
    },
  }),
    (C.Masked = T),
    (C.createMask = D);

  var F = {
      0: /\d/,
      a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
      '*': /./,
    },
    O = (function() {
      function t(e) {
        s(this, t);
        var n = e.mask,
          i = c(e, ['mask']);
        (this.masked = D({
          mask: n,
        })),
          Object.assign(this, i);
      }

      return (
        o(t, [
          {
            key: 'reset',
            value: function() {
              (this._isFilled = !1), this.masked.reset();
            },
          },
          {
            key: 'remove',
            value: function() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length;
              return 0 === t && e >= 1 ? ((this._isFilled = !1), this.masked.remove(t, e)) : new w();
            },
          },
          {
            key: 'value',
            get: function() {
              return this.masked.value || (this._isFilled && !this.isOptional ? this.placeholderChar : '');
            },
          },
          {
            key: 'unmaskedValue',
            get: function() {
              return this.masked.unmaskedValue;
            },
          },
          {
            key: 'isComplete',
            get: function() {
              return Boolean(this.masked.value) || this.isOptional;
            },
          },
          {
            key: '_appendChar',
            value: function(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (this._isFilled) return new w();

              var n = this.masked.state,
                i = this.masked._appendChar(t, e);

              return (
                i.inserted && !1 === this.doValidate(e) && ((i.inserted = i.rawInserted = ''), (this.masked.state = n)),
                i.inserted || this.isOptional || this.lazy || e.input || (i.inserted = this.placeholderChar),
                (i.skip = !i.inserted && !this.isOptional),
                (this._isFilled = Boolean(i.inserted)),
                i
              );
            },
          },
          {
            key: 'append',
            value: function() {
              var t;
              return (t = this.masked).append.apply(t, arguments);
            },
          },
          {
            key: '_appendPlaceholder',
            value: function() {
              var t = new w();
              return this._isFilled || this.isOptional
                ? t
                : ((this._isFilled = !0), (t.inserted = this.placeholderChar), t);
            },
          },
          {
            key: 'extractTail',
            value: function() {
              var t;
              return (t = this.masked).extractTail.apply(t, arguments);
            },
          },
          {
            key: 'appendTail',
            value: function() {
              var t;
              return (t = this.masked).appendTail.apply(t, arguments);
            },
          },
          {
            key: 'extractInput',
            value: function() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
                n = arguments.length > 2 ? arguments[2] : void 0;
              return this.masked.extractInput(t, e, n);
            },
          },
          {
            key: 'nearestInputPos',
            value: function(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : b.NONE,
                n = this.value.length,
                i = Math.min(Math.max(t, 0), n);

              switch (e) {
                case b.LEFT:
                case b.FORCE_LEFT:
                  return this.isComplete ? i : 0;

                case b.RIGHT:
                case b.FORCE_RIGHT:
                  return this.isComplete ? i : n;

                case b.NONE:
                default:
                  return i;
              }
            },
          },
          {
            key: 'doValidate',
            value: function() {
              var t, e;
              return (
                (t = this.masked).doValidate.apply(t, arguments) &&
                (!this.parent || (e = this.parent).doValidate.apply(e, arguments))
              );
            },
          },
          {
            key: 'doCommit',
            value: function() {
              this.masked.doCommit();
            },
          },
          {
            key: 'state',
            get: function() {
              return {
                masked: this.masked.state,
                _isFilled: this._isFilled,
              };
            },
            set: function(t) {
              (this.masked.state = t.masked), (this._isFilled = t._isFilled);
            },
          },
        ]),
        t
      );
    })(),
    x = (function() {
      function t(e) {
        s(this, t), Object.assign(this, e), (this._value = '');
      }

      return (
        o(t, [
          {
            key: 'value',
            get: function() {
              return this._value;
            },
          },
          {
            key: 'unmaskedValue',
            get: function() {
              return this.isUnmasking ? this.value : '';
            },
          },
          {
            key: 'reset',
            value: function() {
              (this._isRawInput = !1), (this._value = '');
            },
          },
          {
            key: 'remove',
            value: function() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._value.length;
              return (
                (this._value = this._value.slice(0, t) + this._value.slice(e)),
                this._value || (this._isRawInput = !1),
                new w()
              );
            },
          },
          {
            key: 'nearestInputPos',
            value: function(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : b.NONE,
                n = this._value.length;

              switch (e) {
                case b.LEFT:
                case b.FORCE_LEFT:
                  return 0;

                case b.NONE:
                case b.RIGHT:
                case b.FORCE_RIGHT:
                default:
                  return n;
              }
            },
          },
          {
            key: 'extractInput',
            value: function() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._value.length;
              return (
                ((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).raw &&
                  this._isRawInput &&
                  this._value.slice(t, e)) ||
                ''
              );
            },
          },
          {
            key: 'isComplete',
            get: function() {
              return !0;
            },
          },
          {
            key: '_appendChar',
            value: function(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = new w();
              if (this._value) return n;
              var i = this.char === t[0] && (this.isUnmasking || e.input || e.raw) && !e.tail;
              return (
                i && (n.rawInserted = this.char),
                (this._value = n.inserted = this.char),
                (this._isRawInput = i && (e.raw || e.input)),
                n
              );
            },
          },
          {
            key: '_appendPlaceholder',
            value: function() {
              var t = new w();
              return this._value ? t : ((this._value = t.inserted = this.char), t);
            },
          },
          {
            key: 'extractTail',
            value: function() {
              return arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length, new A('');
            },
          },
          {
            key: 'appendTail',
            value: function(t) {
              return y(t) && (t = new A(String(t))), t.appendTo(this);
            },
          },
          {
            key: 'append',
            value: function(t, e, n) {
              var i = this._appendChar(t, e);

              return null != n && (i.tailShift += this.appendTail(n).tailShift), i;
            },
          },
          {
            key: 'doCommit',
            value: function() {},
          },
          {
            key: 'state',
            get: function() {
              return {
                _value: this._value,
                _isRawInput: this._isRawInput,
              };
            },
            set: function(t) {
              Object.assign(this, t);
            },
          },
        ]),
        t
      );
    })(),
    L = (function() {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        s(this, t), (this.chunks = e), (this.from = n);
      }

      return (
        o(t, [
          {
            key: 'toString',
            value: function() {
              return this.chunks.map(String).join('');
            },
          },
          {
            key: 'extend',
            value: function(e) {
              if (String(e)) {
                y(e) && (e = new A(String(e)));
                var n = this.chunks[this.chunks.length - 1],
                  i = n && (n.stop === e.stop || null == e.stop) && e.from === n.from + n.toString().length;
                if (e instanceof A) i ? n.extend(e.toString()) : this.chunks.push(e);
                else if (e instanceof t) {
                  if (null == e.stop)
                    for (var s; e.chunks.length && null == e.chunks[0].stop; )
                      ((s = e.chunks.shift()).from += e.from), this.extend(s);
                  e.toString() && ((e.stop = e.blockIndex), this.chunks.push(e));
                }
              }
            },
          },
          {
            key: 'appendTo',
            value: function(e) {
              if (!(e instanceof C.MaskedPattern)) return new A(this.toString()).appendTo(e);

              for (var n = new w(), i = 0; i < this.chunks.length && !n.skip; ++i) {
                var s = this.chunks[i],
                  r = e._mapPosToBlock(e.value.length),
                  o = s.stop,
                  a = void 0;

                if (
                  (null != o &&
                    (!r || r.index <= o) &&
                    ((s instanceof t || e._stops.indexOf(o) >= 0) && n.aggregate(e._appendPlaceholder(o)),
                    (a = s instanceof t && e._blocks[o])),
                  a)
                ) {
                  var u = a.appendTail(s);
                  (u.skip = !1), n.aggregate(u), (e._value += u.inserted);
                  var l = s.toString().slice(u.rawInserted.length);
                  l &&
                    n.aggregate(
                      e.append(l, {
                        tail: !0,
                      })
                    );
                } else
                  n.aggregate(
                    e.append(s.toString(), {
                      tail: !0,
                    })
                  );
              }

              return n;
            },
          },
          {
            key: 'state',
            get: function() {
              return {
                chunks: this.chunks.map(function(t) {
                  return t.state;
                }),
                from: this.from,
                stop: this.stop,
                blockIndex: this.blockIndex,
              };
            },
            set: function(e) {
              var n = e.chunks,
                i = c(e, ['chunks']);
              Object.assign(this, i),
                (this.chunks = n.map(function(e) {
                  var n = 'chunks' in e ? new t() : new A();
                  return (n.state = e), n;
                }));
            },
          },
          {
            key: 'shiftBefore',
            value: function(t) {
              if (this.from >= t || !this.chunks.length) return '';

              for (var e = t - this.from, n = 0; n < this.chunks.length; ) {
                var i = this.chunks[n],
                  s = i.shiftBefore(e);

                if (i.toString()) {
                  if (!s) break;
                  ++n;
                } else this.chunks.splice(n, 1);

                if (s) return s;
              }

              return '';
            },
          },
        ]),
        t
      );
    })(),
    B = (function(t) {
      a(n, T);
      var e = d(n);

      function n() {
        return s(this, n), e.apply(this, arguments);
      }

      return (
        o(n, [
          {
            key: '_update',
            value: function(t) {
              t.mask &&
                (t.validate = function(e) {
                  return e.search(t.mask) >= 0;
                }),
                p(u(n.prototype), '_update', this).call(this, t);
            },
          },
        ]),
        n
      );
    })();

  C.MaskedRegExp = B;

  var P = (function(t) {
    a(n, T);
    var e = d(n);

    function n() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return (
        s(this, n),
        (t.definitions = Object.assign({}, F, t.definitions)),
        e.call(this, Object.assign({}, n.DEFAULTS, t))
      );
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            (t.definitions = Object.assign({}, this.definitions, t.definitions)),
              p(u(n.prototype), '_update', this).call(this, t),
              this._rebuildMask();
          },
        },
        {
          key: '_rebuildMask',
          value: function() {
            var t = this,
              e = this.definitions;
            (this._blocks = []), (this._stops = []), (this._maskedBlocks = {});
            var i = this.mask;
            if (i && e)
              for (var s = !1, r = !1, o = 0; o < i.length; ++o) {
                if (this.blocks)
                  if (
                    'continue' ===
                    (function() {
                      var e = i.slice(o),
                        n = Object.keys(t.blocks).filter(function(t) {
                          return 0 === e.indexOf(t);
                        });
                      n.sort(function(t, e) {
                        return e.length - t.length;
                      });
                      var s = n[0];

                      if (s) {
                        var r = D(
                          Object.assign(
                            {
                              parent: t,
                              lazy: t.lazy,
                              placeholderChar: t.placeholderChar,
                              overwrite: t.overwrite,
                            },
                            t.blocks[s]
                          )
                        );
                        return (
                          r &&
                            (t._blocks.push(r),
                            t._maskedBlocks[s] || (t._maskedBlocks[s] = []),
                            t._maskedBlocks[s].push(t._blocks.length - 1)),
                          (o += s.length - 1),
                          'continue'
                        );
                      }
                    })()
                  )
                    continue;
                var a = i[o],
                  u = a in e;
                if (a !== n.STOP_CHAR) {
                  if ('{' !== a && '}' !== a) {
                    if ('[' !== a && ']' !== a) {
                      if (a === n.ESCAPE_CHAR) {
                        if (!(a = i[++o])) break;
                        u = !1;
                      }

                      var l = u
                        ? new O({
                            parent: this,
                            lazy: this.lazy,
                            placeholderChar: this.placeholderChar,
                            mask: e[a],
                            isOptional: r,
                          })
                        : new x({
                            char: a,
                            isUnmasking: s,
                          });

                      this._blocks.push(l);
                    } else r = !r;
                  } else s = !s;
                } else this._stops.push(this._blocks.length);
              }
          },
        },
        {
          key: 'state',
          get: function() {
            return Object.assign({}, p(u(n.prototype), 'state', this), {
              _blocks: this._blocks.map(function(t) {
                return t.state;
              }),
            });
          },
          set: function(t) {
            var e = t._blocks,
              i = c(t, ['_blocks']);
            this._blocks.forEach(function(t, n) {
              return (t.state = e[n]);
            }),
              m(u(n.prototype), 'state', i, this, !0);
          },
        },
        {
          key: 'reset',
          value: function() {
            p(u(n.prototype), 'reset', this).call(this),
              this._blocks.forEach(function(t) {
                return t.reset();
              });
          },
        },
        {
          key: 'isComplete',
          get: function() {
            return this._blocks.every(function(t) {
              return t.isComplete;
            });
          },
        },
        {
          key: 'doCommit',
          value: function() {
            this._blocks.forEach(function(t) {
              return t.doCommit();
            }),
              p(u(n.prototype), 'doCommit', this).call(this);
          },
        },
        {
          key: 'unmaskedValue',
          get: function() {
            return this._blocks.reduce(function(t, e) {
              return t + e.unmaskedValue;
            }, '');
          },
          set: function(t) {
            m(u(n.prototype), 'unmaskedValue', t, this, !0);
          },
        },
        {
          key: 'value',
          get: function() {
            return this._blocks.reduce(function(t, e) {
              return t + e.value;
            }, '');
          },
          set: function(t) {
            m(u(n.prototype), 'value', t, this, !0);
          },
        },
        {
          key: 'appendTail',
          value: function(t) {
            return p(u(n.prototype), 'appendTail', this)
              .call(this, t)
              .aggregate(this._appendPlaceholder());
          },
        },
        {
          key: '_appendCharRaw',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this._mapPosToBlock(this.value.length),
              i = new w();

            if (!n) return i;

            for (var s = n.index; ; ++s) {
              var r = this._blocks[s];
              if (!r) break;

              var o = r._appendChar(t, e),
                a = o.skip;

              if ((i.aggregate(o), a || o.rawInserted)) break;
            }

            return i;
          },
        },
        {
          key: 'extractTail',
          value: function() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              i = new L();
            return e === n
              ? i
              : (this._forEachBlocksInRange(e, n, function(e, n, s, r) {
                  var o = e.extractTail(s, r);
                  (o.stop = t._findStopBefore(n)),
                    (o.from = t._blockStartPos(n)),
                    o instanceof L && (o.blockIndex = n),
                    i.extend(o);
                }),
                i);
          },
        },
        {
          key: 'extractInput',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (t === e) return '';
            var i = '';
            return (
              this._forEachBlocksInRange(t, e, function(t, e, s, r) {
                i += t.extractInput(s, r, n);
              }),
              i
            );
          },
        },
        {
          key: '_findStopBefore',
          value: function(t) {
            for (var e, n = 0; n < this._stops.length; ++n) {
              var i = this._stops[n];
              if (!(i <= t)) break;
              e = i;
            }

            return e;
          },
        },
        {
          key: '_appendPlaceholder',
          value: function(t) {
            var e = this,
              n = new w();
            if (this.lazy && null == t) return n;

            var i = this._mapPosToBlock(this.value.length);

            if (!i) return n;
            var s = i.index,
              r = null != t ? t : this._blocks.length;
            return (
              this._blocks.slice(s, r).forEach(function(i) {
                if (!i.lazy || null != t) {
                  var s = null != i._blocks ? [i._blocks.length] : [],
                    r = i._appendPlaceholder.apply(i, s);

                  (e._value += r.inserted), n.aggregate(r);
                }
              }),
              n
            );
          },
        },
        {
          key: '_mapPosToBlock',
          value: function(t) {
            for (var e = '', n = 0; n < this._blocks.length; ++n) {
              var i = this._blocks[n],
                s = e.length;
              if (t <= (e += i.value).length)
                return {
                  index: n,
                  offset: t - s,
                };
            }
          },
        },
        {
          key: '_blockStartPos',
          value: function(t) {
            return this._blocks.slice(0, t).reduce(function(t, e) {
              return t + e.value.length;
            }, 0);
          },
        },
        {
          key: '_forEachBlocksInRange',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              n = arguments.length > 2 ? arguments[2] : void 0,
              i = this._mapPosToBlock(t);

            if (i) {
              var s = this._mapPosToBlock(e),
                r = s && i.index === s.index,
                o = i.offset,
                a = s && r ? s.offset : this._blocks[i.index].value.length;

              if ((n(this._blocks[i.index], i.index, o, a), s && !r)) {
                for (var u = i.index + 1; u < s.index; ++u) n(this._blocks[u], u, 0, this._blocks[u].value.length);

                n(this._blocks[s.index], s.index, 0, s.offset);
              }
            }
          },
        },
        {
          key: 'remove',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              i = p(u(n.prototype), 'remove', this).call(this, t, e);
            return (
              this._forEachBlocksInRange(t, e, function(t, e, n, s) {
                i.aggregate(t.remove(n, s));
              }),
              i
            );
          },
        },
        {
          key: 'nearestInputPos',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : b.NONE,
              n = this._mapPosToBlock(t) || {
                index: 0,
                offset: 0,
              },
              i = n.offset,
              s = n.index,
              r = this._blocks[s];
            if (!r) return t;
            var o = i;
            0 !== o &&
              o < r.value.length &&
              (o = r.nearestInputPos(
                i,
                (function(t) {
                  switch (t) {
                    case b.LEFT:
                      return b.FORCE_LEFT;

                    case b.RIGHT:
                      return b.FORCE_RIGHT;

                    default:
                      return t;
                  }
                })(e)
              ));
            var a = o === r.value.length;
            if (!(0 === o) && !a) return this._blockStartPos(s) + o;
            var u = a ? s + 1 : s;

            if (e === b.NONE) {
              if (u > 0) {
                var l = u - 1,
                  c = this._blocks[l],
                  h = c.nearestInputPos(0, b.NONE);
                if (!c.value.length || h !== c.value.length) return this._blockStartPos(u);
              }

              for (var d = u; d < this._blocks.length; ++d) {
                var f = this._blocks[d],
                  p = f.nearestInputPos(0, b.NONE);
                if (!f.value.length || p !== f.value.length) return this._blockStartPos(d) + p;
              }

              for (var g = u - 1; g >= 0; --g) {
                var m = this._blocks[g],
                  v = m.nearestInputPos(0, b.NONE);
                if (!m.value.length || v !== m.value.length) return this._blockStartPos(g) + m.value.length;
              }

              return t;
            }

            if (e === b.LEFT || e === b.FORCE_LEFT) {
              for (var _, y = u; y < this._blocks.length; ++y)
                if (this._blocks[y].value) {
                  _ = y;
                  break;
                }

              if (null != _) {
                var k = this._blocks[_],
                  E = k.nearestInputPos(0, b.RIGHT);
                if (0 === E && k.unmaskedValue.length) return this._blockStartPos(_) + E;
              }

              for (var w, A = -1, C = u - 1; C >= 0; --C) {
                var T = this._blocks[C],
                  S = T.nearestInputPos(T.value.length, b.FORCE_LEFT);

                if (((T.value && 0 === S) || (w = C), 0 !== S)) {
                  if (S !== T.value.length) return this._blockStartPos(C) + S;
                  A = C;
                  break;
                }
              }

              if (e === b.LEFT)
                for (var D = A + 1; D <= Math.min(u, this._blocks.length - 1); ++D) {
                  var F = this._blocks[D],
                    O = F.nearestInputPos(0, b.NONE),
                    x = this._blockStartPos(D) + O;
                  if (x > t) break;
                  if (O !== F.value.length) return x;
                }
              if (A >= 0) return this._blockStartPos(A) + this._blocks[A].value.length;
              if (
                e === b.FORCE_LEFT ||
                (this.lazy &&
                  !this.extractInput() &&
                  !(function(t) {
                    if (!t) return !1;
                    var e = t.value;
                    return !e || t.nearestInputPos(0, b.NONE) !== e.length;
                  })(this._blocks[u]))
              )
                return 0;
              if (null != w) return this._blockStartPos(w);

              for (var L = u; L < this._blocks.length; ++L) {
                var B = this._blocks[L],
                  P = B.nearestInputPos(0, b.NONE);
                if (!B.value.length || P !== B.value.length) return this._blockStartPos(L) + P;
              }

              return 0;
            }

            if (e === b.RIGHT || e === b.FORCE_RIGHT) {
              for (var M, I, N = u; N < this._blocks.length; ++N) {
                var R = this._blocks[N],
                  $ = R.nearestInputPos(0, b.NONE);

                if ($ !== R.value.length) {
                  (I = this._blockStartPos(N) + $), (M = N);
                  break;
                }
              }

              if (null != M && null != I) {
                for (var j = M; j < this._blocks.length; ++j) {
                  var V = this._blocks[j],
                    H = V.nearestInputPos(0, b.FORCE_RIGHT);
                  if (H !== V.value.length) return this._blockStartPos(j) + H;
                }

                return e === b.FORCE_RIGHT ? this.value.length : I;
              }

              for (var W = Math.min(u, this._blocks.length - 1); W >= 0; --W) {
                var z = this._blocks[W],
                  U = z.nearestInputPos(z.value.length, b.LEFT);

                if (0 !== U) {
                  var Y = this._blockStartPos(W) + U;
                  if (Y >= t) return Y;
                  break;
                }
              }
            }

            return t;
          },
        },
        {
          key: 'maskedBlock',
          value: function(t) {
            return this.maskedBlocks(t)[0];
          },
        },
        {
          key: 'maskedBlocks',
          value: function(t) {
            var e = this,
              n = this._maskedBlocks[t];
            return n
              ? n.map(function(t) {
                  return e._blocks[t];
                })
              : [];
          },
        },
      ]),
      n
    );
  })();

  (P.DEFAULTS = {
    lazy: !0,
    placeholderChar: '_',
  }),
    (P.STOP_CHAR = '`'),
    (P.ESCAPE_CHAR = '\\'),
    (P.InputDefinition = O),
    (P.FixedDefinition = x),
    (C.MaskedPattern = P);

  var M = (function(t) {
    a(n, P);
    var e = d(n);

    function n() {
      return s(this, n), e.apply(this, arguments);
    }

    return (
      o(n, [
        {
          key: '_matchFrom',
          get: function() {
            return this.maxLength - String(this.from).length;
          },
        },
        {
          key: '_update',
          value: function(t) {
            t = Object.assign(
              {
                to: this.to || 0,
                from: this.from || 0,
              },
              t
            );
            var e = String(t.to).length;
            null != t.maxLength && (e = Math.max(e, t.maxLength)), (t.maxLength = e);

            for (
              var i = String(t.from).padStart(e, '0'), s = String(t.to).padStart(e, '0'), r = 0;
              r < s.length && s[r] === i[r];

            )
              ++r;

            (t.mask = s.slice(0, r).replace(/0/g, '\\0') + '0'.repeat(e - r)),
              p(u(n.prototype), '_update', this).call(this, t);
          },
        },
        {
          key: 'isComplete',
          get: function() {
            return p(u(n.prototype), 'isComplete', this) && Boolean(this.value);
          },
        },
        {
          key: 'boundaries',
          value: function(t) {
            var e = '',
              n = '',
              i = v(t.match(/^(\D*)(\d*)(\D*)/) || [], 3),
              s = i[1],
              r = i[2];
            return (
              r && ((e = '0'.repeat(s.length) + r), (n = '9'.repeat(s.length) + r)),
              [(e = e.padEnd(this.maxLength, '0')), (n = n.padEnd(this.maxLength, '9'))]
            );
          },
        },
        {
          key: 'doPrepare',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (
              ((t = p(u(n.prototype), 'doPrepare', this)
                .call(this, t, e)
                .replace(/\D/g, '')),
              !this.autofix)
            )
              return t;

            for (
              var i = String(this.from).padStart(this.maxLength, '0'),
                s = String(this.to).padStart(this.maxLength, '0'),
                r = this.value,
                o = '',
                a = 0;
              a < t.length;
              ++a
            ) {
              var l = r + o + t[a],
                c = v(this.boundaries(l), 2),
                h = c[0],
                d = c[1];
              Number(d) < this.from
                ? (o += i[l.length - 1])
                : Number(h) > this.to
                ? (o += s[l.length - 1])
                : (o += t[a]);
            }

            return o;
          },
        },
        {
          key: 'doValidate',
          value: function() {
            var t,
              e = this.value;
            if (-1 === e.search(/[^0]/) && e.length <= this._matchFrom) return !0;

            for (
              var i = v(this.boundaries(e), 2), s = i[0], r = i[1], o = arguments.length, a = new Array(o), l = 0;
              l < o;
              l++
            )
              a[l] = arguments[l];

            return (
              this.from <= Number(r) &&
              Number(s) <= this.to &&
              (t = p(u(n.prototype), 'doValidate', this)).call.apply(t, [this].concat(a))
            );
          },
        },
      ]),
      n
    );
  })();

  C.MaskedRange = M;

  var I = (function(t) {
    a(n, P);
    var e = d(n);

    function n(t) {
      return s(this, n), e.call(this, Object.assign({}, n.DEFAULTS, t));
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function(t) {
            t.mask === Date && delete t.mask, t.pattern && (t.mask = t.pattern);
            var e = t.blocks;
            (t.blocks = Object.assign({}, n.GET_DEFAULT_BLOCKS())),
              t.min && (t.blocks.Y.from = t.min.getFullYear()),
              t.max && (t.blocks.Y.to = t.max.getFullYear()),
              t.min &&
                t.max &&
                t.blocks.Y.from === t.blocks.Y.to &&
                ((t.blocks.m.from = t.min.getMonth() + 1),
                (t.blocks.m.to = t.max.getMonth() + 1),
                t.blocks.m.from === t.blocks.m.to &&
                  ((t.blocks.d.from = t.min.getDate()), (t.blocks.d.to = t.max.getDate()))),
              Object.assign(t.blocks, e),
              Object.keys(t.blocks).forEach(function(e) {
                var n = t.blocks[e];
                'autofix' in n || (n.autofix = t.autofix);
              }),
              p(u(n.prototype), '_update', this).call(this, t);
          },
        },
        {
          key: 'doValidate',
          value: function() {
            for (var t, e = this.date, i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];

            return (
              (t = p(u(n.prototype), 'doValidate', this)).call.apply(t, [this].concat(s)) &&
              (!this.isComplete ||
                (this.isDateExist(this.value) &&
                  null != e &&
                  (null == this.min || this.min <= e) &&
                  (null == this.max || e <= this.max)))
            );
          },
        },
        {
          key: 'isDateExist',
          value: function(t) {
            return this.format(this.parse(t, this), this).indexOf(t) >= 0;
          },
        },
        {
          key: 'date',
          get: function() {
            return this.typedValue;
          },
          set: function(t) {
            this.typedValue = t;
          },
        },
        {
          key: 'typedValue',
          get: function() {
            return this.isComplete ? p(u(n.prototype), 'typedValue', this) : null;
          },
          set: function(t) {
            m(u(n.prototype), 'typedValue', t, this, !0);
          },
        },
      ]),
      n
    );
  })();

  (I.DEFAULTS = {
    pattern: 'd{.}`m{.}`Y',
    format: function(t) {
      return [String(t.getDate()).padStart(2, '0'), String(t.getMonth() + 1).padStart(2, '0'), t.getFullYear()].join(
        '.'
      );
    },
    parse: function(t) {
      var e = v(t.split('.'), 3),
        n = e[0],
        i = e[1],
        s = e[2];
      return new Date(s, i - 1, n);
    },
  }),
    (I.GET_DEFAULT_BLOCKS = function() {
      return {
        d: {
          mask: M,
          from: 1,
          to: 31,
          maxLength: 2,
        },
        m: {
          mask: M,
          from: 1,
          to: 12,
          maxLength: 2,
        },
        Y: {
          mask: M,
          from: 1900,
          to: 9999,
        },
      };
    }),
    (C.MaskedDate = I);

  var N = (function() {
    function t() {
      s(this, t);
    }

    return (
      o(t, [
        {
          key: 'selectionStart',
          get: function() {
            var t;

            try {
              t = this._unsafeSelectionStart;
            } catch (t) {}

            return null != t ? t : this.value.length;
          },
        },
        {
          key: 'selectionEnd',
          get: function() {
            var t;

            try {
              t = this._unsafeSelectionEnd;
            } catch (t) {}

            return null != t ? t : this.value.length;
          },
        },
        {
          key: 'select',
          value: function(t, e) {
            if (null != t && null != e && (t !== this.selectionStart || e !== this.selectionEnd))
              try {
                this._unsafeSelect(t, e);
              } catch (t) {}
          },
        },
        {
          key: '_unsafeSelect',
          value: function(t, e) {},
        },
        {
          key: 'isActive',
          get: function() {
            return !1;
          },
        },
        {
          key: 'bindEvents',
          value: function(t) {},
        },
        {
          key: 'unbindEvents',
          value: function() {},
        },
      ]),
      t
    );
  })();

  C.MaskElement = N;

  var R = (function(t) {
    a(n, N);
    var e = d(n);

    function n(t) {
      var i;
      return s(this, n), ((i = e.call(this)).input = t), (i._handlers = {}), i;
    }

    return (
      o(n, [
        {
          key: 'rootElement',
          get: function() {
            return this.input.getRootNode ? this.input.getRootNode() : document;
          },
        },
        {
          key: 'isActive',
          get: function() {
            return this.input === this.rootElement.activeElement;
          },
        },
        {
          key: '_unsafeSelectionStart',
          get: function() {
            return this.input.selectionStart;
          },
        },
        {
          key: '_unsafeSelectionEnd',
          get: function() {
            return this.input.selectionEnd;
          },
        },
        {
          key: '_unsafeSelect',
          value: function(t, e) {
            this.input.setSelectionRange(t, e);
          },
        },
        {
          key: 'value',
          get: function() {
            return this.input.value;
          },
          set: function(t) {
            this.input.value = t;
          },
        },
        {
          key: 'bindEvents',
          value: function(t) {
            var e = this;
            Object.keys(t).forEach(function(i) {
              return e._toggleEventHandler(n.EVENTS_MAP[i], t[i]);
            });
          },
        },
        {
          key: 'unbindEvents',
          value: function() {
            var t = this;
            Object.keys(this._handlers).forEach(function(e) {
              return t._toggleEventHandler(e);
            });
          },
        },
        {
          key: '_toggleEventHandler',
          value: function(t, e) {
            this._handlers[t] && (this.input.removeEventListener(t, this._handlers[t]), delete this._handlers[t]),
              e && (this.input.addEventListener(t, e), (this._handlers[t] = e));
          },
        },
      ]),
      n
    );
  })();

  (R.EVENTS_MAP = {
    selectionChange: 'keydown',
    input: 'input',
    drop: 'drop',
    click: 'click',
    focus: 'focus',
    commit: 'blur',
  }),
    (C.HTMLMaskElement = R);

  var $ = (function(t) {
    a(n, R);
    var e = d(n);

    function n() {
      return s(this, n), e.apply(this, arguments);
    }

    return (
      o(n, [
        {
          key: '_unsafeSelectionStart',
          get: function() {
            var t = this.rootElement,
              e = t.getSelection && t.getSelection();
            return e && e.anchorOffset;
          },
        },
        {
          key: '_unsafeSelectionEnd',
          get: function() {
            var t = this.rootElement,
              e = t.getSelection && t.getSelection();
            return e && this._unsafeSelectionStart + String(e).length;
          },
        },
        {
          key: '_unsafeSelect',
          value: function(t, e) {
            if (this.rootElement.createRange) {
              var n = this.rootElement.createRange();
              n.setStart(this.input.firstChild || this.input, t), n.setEnd(this.input.lastChild || this.input, e);
              var i = this.rootElement,
                s = i.getSelection && i.getSelection();
              s && (s.removeAllRanges(), s.addRange(n));
            }
          },
        },
        {
          key: 'value',
          get: function() {
            return this.input.textContent;
          },
          set: function(t) {
            this.input.textContent = t;
          },
        },
      ]),
      n
    );
  })();

  C.HTMLContenteditableMaskElement = $;

  var j = (function() {
    function t(e, n) {
      s(this, t),
        (this.el =
          e instanceof N
            ? e
            : e.isContentEditable && 'INPUT' !== e.tagName && 'TEXTAREA' !== e.tagName
            ? new $(e)
            : new R(e)),
        (this.masked = D(n)),
        (this._listeners = {}),
        (this._value = ''),
        (this._unmaskedValue = ''),
        (this._saveSelection = this._saveSelection.bind(this)),
        (this._onInput = this._onInput.bind(this)),
        (this._onChange = this._onChange.bind(this)),
        (this._onDrop = this._onDrop.bind(this)),
        (this._onFocus = this._onFocus.bind(this)),
        (this._onClick = this._onClick.bind(this)),
        (this.alignCursor = this.alignCursor.bind(this)),
        (this.alignCursorFriendly = this.alignCursorFriendly.bind(this)),
        this._bindEvents(),
        this.updateValue(),
        this._onChange();
    }

    return (
      o(t, [
        {
          key: 'mask',
          get: function() {
            return this.masked.mask;
          },
          set: function(t) {
            if (!this.maskEquals(t))
              if (t instanceof C.Masked || this.masked.constructor !== S(t)) {
                var e = D({
                  mask: t,
                });
                (e.unmaskedValue = this.masked.unmaskedValue), (this.masked = e);
              } else
                this.masked.updateOptions({
                  mask: t,
                });
          },
        },
        {
          key: 'maskEquals',
          value: function(t) {
            return null == t || t === this.masked.mask || (t === Date && this.masked instanceof I);
          },
        },
        {
          key: 'value',
          get: function() {
            return this._value;
          },
          set: function(t) {
            (this.masked.value = t), this.updateControl(), this.alignCursor();
          },
        },
        {
          key: 'unmaskedValue',
          get: function() {
            return this._unmaskedValue;
          },
          set: function(t) {
            (this.masked.unmaskedValue = t), this.updateControl(), this.alignCursor();
          },
        },
        {
          key: 'typedValue',
          get: function() {
            return this.masked.typedValue;
          },
          set: function(t) {
            (this.masked.typedValue = t), this.updateControl(), this.alignCursor();
          },
        },
        {
          key: '_bindEvents',
          value: function() {
            this.el.bindEvents({
              selectionChange: this._saveSelection,
              input: this._onInput,
              drop: this._onDrop,
              click: this._onClick,
              focus: this._onFocus,
              commit: this._onChange,
            });
          },
        },
        {
          key: '_unbindEvents',
          value: function() {
            this.el && this.el.unbindEvents();
          },
        },
        {
          key: '_fireEvent',
          value: function(t) {
            for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];

            var s = this._listeners[t];
            s &&
              s.forEach(function(t) {
                return t.apply(void 0, n);
              });
          },
        },
        {
          key: 'selectionStart',
          get: function() {
            return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
          },
        },
        {
          key: 'cursorPos',
          get: function() {
            return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
          },
          set: function(t) {
            this.el && this.el.isActive && (this.el.select(t, t), this._saveSelection());
          },
        },
        {
          key: '_saveSelection',
          value: function() {
            this.value !== this.el.value &&
              console.warn(
                'Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'
              ),
              (this._selection = {
                start: this.selectionStart,
                end: this.cursorPos,
              });
          },
        },
        {
          key: 'updateValue',
          value: function() {
            (this.masked.value = this.el.value), (this._value = this.masked.value);
          },
        },
        {
          key: 'updateControl',
          value: function() {
            var t = this.masked.unmaskedValue,
              e = this.masked.value,
              n = this.unmaskedValue !== t || this.value !== e;
            (this._unmaskedValue = t),
              (this._value = e),
              this.el.value !== e && (this.el.value = e),
              n && this._fireChangeEvents();
          },
        },
        {
          key: 'updateOptions',
          value: function(t) {
            var e = t.mask,
              n = c(t, ['mask']),
              s = !this.maskEquals(e),
              r = !(function t(e, n) {
                if (n === e) return !0;
                var s,
                  r = Array.isArray(n),
                  o = Array.isArray(e);

                if (r && o) {
                  if (n.length != e.length) return !1;

                  for (s = 0; s < n.length; s++) if (!t(n[s], e[s])) return !1;

                  return !0;
                }

                if (r != o) return !1;

                if (n && e && 'object' === i(n) && 'object' === i(e)) {
                  var a = n instanceof Date,
                    u = e instanceof Date;
                  if (a && u) return n.getTime() == e.getTime();
                  if (a != u) return !1;
                  var l = n instanceof RegExp,
                    c = e instanceof RegExp;
                  if (l && c) return n.toString() == e.toString();
                  if (l != c) return !1;
                  var h = Object.keys(n);

                  for (s = 0; s < h.length; s++) if (!Object.prototype.hasOwnProperty.call(e, h[s])) return !1;

                  for (s = 0; s < h.length; s++) if (!t(e[h[s]], n[h[s]])) return !1;

                  return !0;
                }

                return !(!n || !e || 'function' != typeof n || 'function' != typeof e) && n.toString() === e.toString();
              })(this.masked, n);
            s && (this.mask = e), r && this.masked.updateOptions(n), (s || r) && this.updateControl();
          },
        },
        {
          key: 'updateCursor',
          value: function(t) {
            null != t && ((this.cursorPos = t), this._delayUpdateCursor(t));
          },
        },
        {
          key: '_delayUpdateCursor',
          value: function(t) {
            var e = this;
            this._abortUpdateCursor(),
              (this._changingCursorPos = t),
              (this._cursorChanging = setTimeout(function() {
                e.el && ((e.cursorPos = e._changingCursorPos), e._abortUpdateCursor());
              }, 10));
          },
        },
        {
          key: '_fireChangeEvents',
          value: function() {
            this._fireEvent('accept', this._inputEvent),
              this.masked.isComplete && this._fireEvent('complete', this._inputEvent);
          },
        },
        {
          key: '_abortUpdateCursor',
          value: function() {
            this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
          },
        },
        {
          key: 'alignCursor',
          value: function() {
            this.cursorPos = this.masked.nearestInputPos(this.cursorPos, b.LEFT);
          },
        },
        {
          key: 'alignCursorFriendly',
          value: function() {
            this.selectionStart === this.cursorPos && this.alignCursor();
          },
        },
        {
          key: 'on',
          value: function(t, e) {
            return this._listeners[t] || (this._listeners[t] = []), this._listeners[t].push(e), this;
          },
        },
        {
          key: 'off',
          value: function(t, e) {
            if (!this._listeners[t]) return this;
            if (!e) return delete this._listeners[t], this;

            var n = this._listeners[t].indexOf(e);

            return n >= 0 && this._listeners[t].splice(n, 1), this;
          },
        },
        {
          key: '_onInput',
          value: function(t) {
            if (((this._inputEvent = t), this._abortUpdateCursor(), !this._selection)) return this.updateValue();
            var e = new E(this.el.value, this.cursorPos, this.value, this._selection),
              n = this.masked.rawInputValue,
              i = this.masked.splice(e.startChangePos, e.removed.length, e.inserted, e.removeDirection).offset,
              s = n === this.masked.rawInputValue ? e.removeDirection : b.NONE,
              r = this.masked.nearestInputPos(e.startChangePos + i, s);
            this.updateControl(), this.updateCursor(r), delete this._inputEvent;
          },
        },
        {
          key: '_onChange',
          value: function() {
            this.value !== this.el.value && this.updateValue(),
              this.masked.doCommit(),
              this.updateControl(),
              this._saveSelection();
          },
        },
        {
          key: '_onDrop',
          value: function(t) {
            t.preventDefault(), t.stopPropagation();
          },
        },
        {
          key: '_onFocus',
          value: function(t) {
            this.alignCursorFriendly();
          },
        },
        {
          key: '_onClick',
          value: function(t) {
            this.alignCursorFriendly();
          },
        },
        {
          key: 'destroy',
          value: function() {
            this._unbindEvents(), (this._listeners.length = 0), delete this.el;
          },
        },
      ]),
      t
    );
  })();

  C.InputMask = j;

  var V = (function(t) {
    a(n, P);
    var e = d(n);

    function n() {
      return s(this, n), e.apply(this, arguments);
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function(t) {
            t.enum && (t.mask = '*'.repeat(t.enum[0].length)), p(u(n.prototype), '_update', this).call(this, t);
          },
        },
        {
          key: 'doValidate',
          value: function() {
            for (var t, e = this, i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];

            return (
              this.enum.some(function(t) {
                return t.indexOf(e.unmaskedValue) >= 0;
              }) && (t = p(u(n.prototype), 'doValidate', this)).call.apply(t, [this].concat(s))
            );
          },
        },
      ]),
      n
    );
  })();

  C.MaskedEnum = V;

  var H = (function(t) {
    a(n, T);
    var e = d(n);

    function n(t) {
      return s(this, n), e.call(this, Object.assign({}, n.DEFAULTS, t));
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function(t) {
            p(u(n.prototype), '_update', this).call(this, t), this._updateRegExps();
          },
        },
        {
          key: '_updateRegExps',
          value: function() {
            var t = '^' + (this.allowNegative ? '[+|\\-]?' : ''),
              e = (this.scale ? '(' + k(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
            (this._numberRegExpInput = new RegExp(t + '(0|([1-9]+\\d*))?' + e)),
              (this._numberRegExp = new RegExp(t + '\\d*' + e)),
              (this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(k).join('') + ']', 'g')),
              (this._thousandsSeparatorRegExp = new RegExp(k(this.thousandsSeparator), 'g'));
          },
        },
        {
          key: '_removeThousandsSeparators',
          value: function(t) {
            return t.replace(this._thousandsSeparatorRegExp, '');
          },
        },
        {
          key: '_insertThousandsSeparators',
          value: function(t) {
            var e = t.split(this.radix);
            return (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator)), e.join(this.radix);
          },
        },
        {
          key: 'doPrepare',
          value: function(t) {
            for (var e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)
              s[r - 1] = arguments[r];

            return (e = p(u(n.prototype), 'doPrepare', this)).call.apply(
              e,
              [this, this._removeThousandsSeparators(t.replace(this._mapToRadixRegExp, this.radix))].concat(s)
            );
          },
        },
        {
          key: '_separatorsCount',
          value: function(t) {
            for (var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = 0, i = 0; i < t; ++i)
              this._value.indexOf(this.thousandsSeparator, i) === i &&
                (++n, e && (t += this.thousandsSeparator.length));

            return n;
          },
        },
        {
          key: '_separatorsCountFromSlice',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._value;
            return this._separatorsCount(this._removeThousandsSeparators(t).length, !0);
          },
        },
        {
          key: 'extractInput',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              i = arguments.length > 2 ? arguments[2] : void 0,
              s = v(this._adjustRangeWithSeparators(t, e), 2);
            return (
              (t = s[0]),
              (e = s[1]),
              this._removeThousandsSeparators(p(u(n.prototype), 'extractInput', this).call(this, t, e, i))
            );
          },
        },
        {
          key: '_appendCharRaw',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!this.thousandsSeparator) return p(u(n.prototype), '_appendCharRaw', this).call(this, t, e);

            var i = e.tail && e._beforeTailState ? e._beforeTailState._value : this._value,
              s = this._separatorsCountFromSlice(i);

            this._value = this._removeThousandsSeparators(this.value);
            var r = p(u(n.prototype), '_appendCharRaw', this).call(this, t, e);
            this._value = this._insertThousandsSeparators(this._value);

            var o = e.tail && e._beforeTailState ? e._beforeTailState._value : this._value,
              a = this._separatorsCountFromSlice(o);

            return (
              (r.tailShift += (a - s) * this.thousandsSeparator.length),
              (r.skip = !r.rawInserted && t === this.thousandsSeparator),
              r
            );
          },
        },
        {
          key: '_findSeparatorAround',
          value: function(t) {
            if (this.thousandsSeparator) {
              var e = t - this.thousandsSeparator.length + 1,
                n = this.value.indexOf(this.thousandsSeparator, e);
              if (n <= t) return n;
            }

            return -1;
          },
        },
        {
          key: '_adjustRangeWithSeparators',
          value: function(t, e) {
            var n = this._findSeparatorAround(t);

            n >= 0 && (t = n);

            var i = this._findSeparatorAround(e);

            return i >= 0 && (e = i + this.thousandsSeparator.length), [t, e];
          },
        },
        {
          key: 'remove',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.value.length,
              n = v(this._adjustRangeWithSeparators(t, e), 2);
            (t = n[0]), (e = n[1]);

            var i = this.value.slice(0, t),
              s = this.value.slice(e),
              r = this._separatorsCount(i.length);

            this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(i + s));

            var o = this._separatorsCountFromSlice(i);

            return new w({
              tailShift: (o - r) * this.thousandsSeparator.length,
            });
          },
        },
        {
          key: 'nearestInputPos',
          value: function(t, e) {
            if (!this.thousandsSeparator) return t;

            switch (e) {
              case b.NONE:
              case b.LEFT:
              case b.FORCE_LEFT:
                var n = this._findSeparatorAround(t - 1);

                if (n >= 0) {
                  var i = n + this.thousandsSeparator.length;
                  if (t < i || this.value.length <= i || e === b.FORCE_LEFT) return n;
                }

                break;

              case b.RIGHT:
              case b.FORCE_RIGHT:
                var s = this._findSeparatorAround(t);

                if (s >= 0) return s + this.thousandsSeparator.length;
            }

            return t;
          },
        },
        {
          key: 'doValidate',
          value: function(t) {
            var e = (t.input ? this._numberRegExpInput : this._numberRegExp).test(
              this._removeThousandsSeparators(this.value)
            );

            if (e) {
              var i = this.number;
              e =
                e &&
                !isNaN(i) &&
                (null == this.min || this.min >= 0 || this.min <= this.number) &&
                (null == this.max || this.max <= 0 || this.number <= this.max);
            }

            return e && p(u(n.prototype), 'doValidate', this).call(this, t);
          },
        },
        {
          key: 'doCommit',
          value: function() {
            if (this.value) {
              var t = this.number,
                e = t;
              null != this.min && (e = Math.max(e, this.min)),
                null != this.max && (e = Math.min(e, this.max)),
                e !== t && (this.unmaskedValue = String(e));
              var i = this.value;
              this.normalizeZeros && (i = this._normalizeZeros(i)),
                this.padFractionalZeros && (i = this._padFractionalZeros(i)),
                (this._value = i);
            }

            p(u(n.prototype), 'doCommit', this).call(this);
          },
        },
        {
          key: '_normalizeZeros',
          value: function(t) {
            var e = this._removeThousandsSeparators(t).split(this.radix);

            return (
              (e[0] = e[0].replace(/^(\D*)(0*)(\d*)/, function(t, e, n, i) {
                return e + i;
              })),
              t.length && !/\d$/.test(e[0]) && (e[0] = e[0] + '0'),
              e.length > 1 && ((e[1] = e[1].replace(/0*$/, '')), e[1].length || (e.length = 1)),
              this._insertThousandsSeparators(e.join(this.radix))
            );
          },
        },
        {
          key: '_padFractionalZeros',
          value: function(t) {
            if (!t) return t;
            var e = t.split(this.radix);
            return e.length < 2 && e.push(''), (e[1] = e[1].padEnd(this.scale, '0')), e.join(this.radix);
          },
        },
        {
          key: 'unmaskedValue',
          get: function() {
            return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, '.');
          },
          set: function(t) {
            m(u(n.prototype), 'unmaskedValue', t.replace('.', this.radix), this, !0);
          },
        },
        {
          key: 'typedValue',
          get: function() {
            return Number(this.unmaskedValue);
          },
          set: function(t) {
            m(u(n.prototype), 'unmaskedValue', String(t), this, !0);
          },
        },
        {
          key: 'number',
          get: function() {
            return this.typedValue;
          },
          set: function(t) {
            this.typedValue = t;
          },
        },
        {
          key: 'allowNegative',
          get: function() {
            return this.signed || (null != this.min && this.min < 0) || (null != this.max && this.max < 0);
          },
        },
      ]),
      n
    );
  })();

  (H.DEFAULTS = {
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: ['.'],
    scale: 2,
    signed: !1,
    normalizeZeros: !0,
    padFractionalZeros: !1,
  }),
    (C.MaskedNumber = H);

  var W = (function(t) {
    a(n, T);
    var e = d(n);

    function n() {
      return s(this, n), e.apply(this, arguments);
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function(t) {
            t.mask && (t.validate = t.mask), p(u(n.prototype), '_update', this).call(this, t);
          },
        },
      ]),
      n
    );
  })();

  C.MaskedFunction = W;

  var z = (function(t) {
    a(n, T);
    var e = d(n);

    function n(t) {
      var i;
      return s(this, n), ((i = e.call(this, Object.assign({}, n.DEFAULTS, t))).currentMask = null), i;
    }

    return (
      o(n, [
        {
          key: '_update',
          value: function(t) {
            p(u(n.prototype), '_update', this).call(this, t),
              'mask' in t &&
                (this.compiledMasks = Array.isArray(t.mask)
                  ? t.mask.map(function(t) {
                      return D(t);
                    })
                  : []);
          },
        },
        {
          key: '_appendCharRaw',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this._applyDispatch(t, e);

            return this.currentMask && n.aggregate(this.currentMask._appendChar(t, e)), n;
          },
        },
        {
          key: '_applyDispatch',
          value: function() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.tail && null != e._beforeTailState ? e._beforeTailState._value : this.value,
              i = this.rawInputValue,
              s = e.tail && null != e._beforeTailState ? e._beforeTailState._rawInputValue : i,
              r = i.slice(s.length),
              o = this.currentMask,
              a = new w(),
              u = o && o.state;
            if (((this.currentMask = this.doDispatch(t, Object.assign({}, e))), this.currentMask))
              if (this.currentMask !== o) {
                if ((this.currentMask.reset(), s)) {
                  var l = this.currentMask.append(s, {
                    raw: !0,
                  });
                  a.tailShift = l.inserted.length - n.length;
                }

                r &&
                  (a.tailShift += this.currentMask.append(r, {
                    raw: !0,
                    tail: !0,
                  }).tailShift);
              } else this.currentMask.state = u;
            return a;
          },
        },
        {
          key: '_appendPlaceholder',
          value: function() {
            var t = this._applyDispatch.apply(this, arguments);

            return this.currentMask && t.aggregate(this.currentMask._appendPlaceholder()), t;
          },
        },
        {
          key: 'doDispatch',
          value: function(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.dispatch(t, this, e);
          },
        },
        {
          key: 'doValidate',
          value: function() {
            for (var t, e, i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];

            return (
              (t = p(u(n.prototype), 'doValidate', this)).call.apply(t, [this].concat(s)) &&
              (!this.currentMask || (e = this.currentMask).doValidate.apply(e, s))
            );
          },
        },
        {
          key: 'reset',
          value: function() {
            this.currentMask && this.currentMask.reset(),
              this.compiledMasks.forEach(function(t) {
                return t.reset();
              });
          },
        },
        {
          key: 'value',
          get: function() {
            return this.currentMask ? this.currentMask.value : '';
          },
          set: function(t) {
            m(u(n.prototype), 'value', t, this, !0);
          },
        },
        {
          key: 'unmaskedValue',
          get: function() {
            return this.currentMask ? this.currentMask.unmaskedValue : '';
          },
          set: function(t) {
            m(u(n.prototype), 'unmaskedValue', t, this, !0);
          },
        },
        {
          key: 'typedValue',
          get: function() {
            return this.currentMask ? this.currentMask.typedValue : '';
          },
          set: function(t) {
            var e = String(t);
            this.currentMask && ((this.currentMask.typedValue = t), (e = this.currentMask.unmaskedValue)),
              (this.unmaskedValue = e);
          },
        },
        {
          key: 'isComplete',
          get: function() {
            return !!this.currentMask && this.currentMask.isComplete;
          },
        },
        {
          key: 'remove',
          value: function() {
            var t,
              e = new w();
            this.currentMask &&
              e.aggregate((t = this.currentMask).remove.apply(t, arguments)).aggregate(this._applyDispatch());
            return e;
          },
        },
        {
          key: 'state',
          get: function() {
            return Object.assign({}, p(u(n.prototype), 'state', this), {
              _rawInputValue: this.rawInputValue,
              compiledMasks: this.compiledMasks.map(function(t) {
                return t.state;
              }),
              currentMaskRef: this.currentMask,
              currentMask: this.currentMask && this.currentMask.state,
            });
          },
          set: function(t) {
            var e = t.compiledMasks,
              i = t.currentMaskRef,
              s = t.currentMask,
              r = c(t, ['compiledMasks', 'currentMaskRef', 'currentMask']);
            this.compiledMasks.forEach(function(t, n) {
              return (t.state = e[n]);
            }),
              null != i && ((this.currentMask = i), (this.currentMask.state = s)),
              m(u(n.prototype), 'state', r, this, !0);
          },
        },
        {
          key: 'extractInput',
          value: function() {
            var t;
            return this.currentMask ? (t = this.currentMask).extractInput.apply(t, arguments) : '';
          },
        },
        {
          key: 'extractTail',
          value: function() {
            for (var t, e, i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];

            return this.currentMask
              ? (t = this.currentMask).extractTail.apply(t, s)
              : (e = p(u(n.prototype), 'extractTail', this)).call.apply(e, [this].concat(s));
          },
        },
        {
          key: 'doCommit',
          value: function() {
            this.currentMask && this.currentMask.doCommit(), p(u(n.prototype), 'doCommit', this).call(this);
          },
        },
        {
          key: 'nearestInputPos',
          value: function() {
            for (var t, e, i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];

            return this.currentMask
              ? (t = this.currentMask).nearestInputPos.apply(t, s)
              : (e = p(u(n.prototype), 'nearestInputPos', this)).call.apply(e, [this].concat(s));
          },
        },
        {
          key: 'overwrite',
          get: function() {
            return this.currentMask ? this.currentMask.overwrite : p(u(n.prototype), 'overwrite', this);
          },
          set: function(t) {
            console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
          },
        },
      ]),
      n
    );
  })();

  (z.DEFAULTS = {
    dispatch: function(t, e, n) {
      if (e.compiledMasks.length) {
        var i = e.rawInputValue,
          s = e.compiledMasks.map(function(e, s) {
            return (
              e.reset(),
              e.append(i, {
                raw: !0,
              }),
              e.append(t, n),
              {
                weight: e.rawInputValue.length,
                index: s,
              }
            );
          });
        return (
          s.sort(function(t, e) {
            return e.weight - t.weight;
          }),
          e.compiledMasks[s[0].index]
        );
      }
    },
  }),
    (C.MaskedDynamic = z);
  var U = {
    MASKED: 'value',
    UNMASKED: 'unmaskedValue',
    TYPED: 'typedValue',
  };

  function Y(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : U.MASKED,
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : U.MASKED,
      i = D(t);
    return function(t) {
      return i.runIsolated(function(i) {
        return (i[e] = t), i[n];
      });
    };
  }

  (C.PIPE_TYPE = U),
    (C.createPipe = Y),
    (C.pipe = function(t) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) n[i - 1] = arguments[i];

      return Y.apply(void 0, n)(t);
    });

  try {
    globalThis.IMask = C;
  } catch (t) {}

  [].slice.call(document.querySelectorAll('[data-mask]')).map(function(t) {
    return new C(t, {
      mask: t.dataset.mask,
      lazy: 'true' === t.dataset['mask-visible'],
    });
  });
  var q = 'top',
    K = 'bottom',
    G = 'right',
    X = 'left',
    Q = 'auto',
    Z = [q, K, G, X],
    J = 'start',
    tt = 'end',
    et = 'clippingParents',
    nt = 'viewport',
    it = 'popper',
    st = 'reference',
    rt = Z.reduce(function(t, e) {
      return t.concat([e + '-' + J, e + '-' + tt]);
    }, []),
    ot = [].concat(Z, [Q]).reduce(function(t, e) {
      return t.concat([e, e + '-' + J, e + '-' + tt]);
    }, []),
    at = ['beforeRead', 'read', 'afterRead', 'beforeMain', 'main', 'afterMain', 'beforeWrite', 'write', 'afterWrite'];

  function ut(t) {
    return t ? (t.nodeName || '').toLowerCase() : null;
  }

  function lt(t) {
    if (null == t) return window;

    if ('[object Window]' !== t.toString()) {
      var e = t.ownerDocument;
      return (e && e.defaultView) || window;
    }

    return t;
  }

  function ct(t) {
    return t instanceof lt(t).Element || t instanceof Element;
  }

  function ht(t) {
    return t instanceof lt(t).HTMLElement || t instanceof HTMLElement;
  }

  function dt(t) {
    return 'undefined' != typeof ShadowRoot && (t instanceof lt(t).ShadowRoot || t instanceof ShadowRoot);
  }

  var ft = {
    name: 'applyStyles',
    enabled: !0,
    phase: 'write',
    fn: function(t) {
      var e = t.state;
      Object.keys(e.elements).forEach(function(t) {
        var n = e.styles[t] || {},
          i = e.attributes[t] || {},
          s = e.elements[t];
        ht(s) &&
          ut(s) &&
          (Object.assign(s.style, n),
          Object.keys(i).forEach(function(t) {
            var e = i[t];
            !1 === e ? s.removeAttribute(t) : s.setAttribute(t, !0 === e ? '' : e);
          }));
      });
    },
    effect: function(t) {
      var e = t.state,
        n = {
          popper: {
            position: e.options.strategy,
            left: '0',
            top: '0',
            margin: '0',
          },
          arrow: {
            position: 'absolute',
          },
          reference: {},
        };
      return (
        Object.assign(e.elements.popper.style, n.popper),
        (e.styles = n),
        e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow),
        function() {
          Object.keys(e.elements).forEach(function(t) {
            var i = e.elements[t],
              s = e.attributes[t] || {},
              r = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : n[t]).reduce(function(t, e) {
                return (t[e] = ''), t;
              }, {});
            ht(i) &&
              ut(i) &&
              (Object.assign(i.style, r),
              Object.keys(s).forEach(function(t) {
                i.removeAttribute(t);
              }));
          });
        }
      );
    },
    requires: ['computeStyles'],
  };

  function pt(t) {
    return t.split('-')[0];
  }

  function gt(t) {
    var e = t.getBoundingClientRect();
    return {
      width: e.width,
      height: e.height,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left,
      x: e.left,
      y: e.top,
    };
  }

  function mt(t) {
    var e = gt(t),
      n = t.offsetWidth,
      i = t.offsetHeight;
    return (
      Math.abs(e.width - n) <= 1 && (n = e.width),
      Math.abs(e.height - i) <= 1 && (i = e.height),
      {
        x: t.offsetLeft,
        y: t.offsetTop,
        width: n,
        height: i,
      }
    );
  }

  function vt(t, e) {
    var n = e.getRootNode && e.getRootNode();
    if (t.contains(e)) return !0;

    if (n && dt(n)) {
      var i = e;

      do {
        if (i && t.isSameNode(i)) return !0;
        i = i.parentNode || i.host;
      } while (i);
    }

    return !1;
  }

  function _t(t) {
    return lt(t).getComputedStyle(t);
  }

  function yt(t) {
    return ['table', 'td', 'th'].indexOf(ut(t)) >= 0;
  }

  function bt(t) {
    return ((ct(t) ? t.ownerDocument : t.document) || window.document).documentElement;
  }

  function kt(t) {
    return 'html' === ut(t) ? t : t.assignedSlot || t.parentNode || (dt(t) ? t.host : null) || bt(t);
  }

  function Et(t) {
    return ht(t) && 'fixed' !== _t(t).position ? t.offsetParent : null;
  }

  function wt(t) {
    for (var e = lt(t), n = Et(t); n && yt(n) && 'static' === _t(n).position; ) n = Et(n);

    return n && ('html' === ut(n) || ('body' === ut(n) && 'static' === _t(n).position))
      ? e
      : n ||
          (function(t) {
            var e = -1 !== navigator.userAgent.toLowerCase().indexOf('firefox');
            if (-1 !== navigator.userAgent.indexOf('Trident') && ht(t) && 'fixed' === _t(t).position) return null;

            for (var n = kt(t); ht(n) && ['html', 'body'].indexOf(ut(n)) < 0; ) {
              var i = _t(n);

              if (
                'none' !== i.transform ||
                'none' !== i.perspective ||
                'paint' === i.contain ||
                -1 !== ['transform', 'perspective'].indexOf(i.willChange) ||
                (e && 'filter' === i.willChange) ||
                (e && i.filter && 'none' !== i.filter)
              )
                return n;
              n = n.parentNode;
            }

            return null;
          })(t) ||
          e;
  }

  function At(t) {
    return ['top', 'bottom'].indexOf(t) >= 0 ? 'x' : 'y';
  }

  var Ct = Math.max,
    Tt = Math.min,
    St = Math.round;

  function Dt(t, e, n) {
    return Ct(t, Tt(e, n));
  }

  function Ft(t) {
    return Object.assign(
      {},
      {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      t
    );
  }

  function Ot(t, e) {
    return e.reduce(function(e, n) {
      return (e[n] = t), e;
    }, {});
  }

  var xt = function(t, e) {
    return Ft(
      'number' !=
        typeof (t =
          'function' == typeof t
            ? t(
                Object.assign({}, e.rects, {
                  placement: e.placement,
                })
              )
            : t)
        ? t
        : Ot(t, Z)
    );
  };

  var Lt = {
      name: 'arrow',
      enabled: !0,
      phase: 'main',
      fn: function(t) {
        var e,
          n = t.state,
          i = t.name,
          s = t.options,
          r = n.elements.arrow,
          o = n.modifiersData.popperOffsets,
          a = pt(n.placement),
          u = At(a),
          l = [X, G].indexOf(a) >= 0 ? 'height' : 'width';

        if (r && o) {
          var c = xt(s.padding, n),
            h = mt(r),
            d = 'y' === u ? q : X,
            f = 'y' === u ? K : G,
            p = n.rects.reference[l] + n.rects.reference[u] - o[u] - n.rects.popper[l],
            g = o[u] - n.rects.reference[u],
            m = wt(r),
            v = m ? ('y' === u ? m.clientHeight || 0 : m.clientWidth || 0) : 0,
            _ = p / 2 - g / 2,
            y = c[d],
            b = v - h[l] - c[f],
            k = v / 2 - h[l] / 2 + _,
            E = Dt(y, k, b),
            w = u;

          n.modifiersData[i] = (((e = {})[w] = E), (e.centerOffset = E - k), e);
        }
      },
      effect: function(t) {
        var e = t.state,
          n = t.options.element,
          i = void 0 === n ? '[data-popper-arrow]' : n;
        null != i &&
          ('string' != typeof i || (i = e.elements.popper.querySelector(i))) &&
          vt(e.elements.popper, i) &&
          (e.elements.arrow = i);
      },
      requires: ['popperOffsets'],
      requiresIfExists: ['preventOverflow'],
    },
    Bt = {
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      left: 'auto',
    };

  function Pt(t) {
    var e,
      n = t.popper,
      i = t.popperRect,
      s = t.placement,
      r = t.offsets,
      o = t.position,
      a = t.gpuAcceleration,
      u = t.adaptive,
      l = t.roundOffsets,
      c =
        !0 === l
          ? (function(t) {
              var e = t.x,
                n = t.y,
                i = window.devicePixelRatio || 1;
              return {
                x: St(St(e * i) / i) || 0,
                y: St(St(n * i) / i) || 0,
              };
            })(r)
          : 'function' == typeof l
          ? l(r)
          : r,
      h = c.x,
      d = void 0 === h ? 0 : h,
      f = c.y,
      p = void 0 === f ? 0 : f,
      g = r.hasOwnProperty('x'),
      m = r.hasOwnProperty('y'),
      v = X,
      _ = q,
      y = window;

    if (u) {
      var b = wt(n),
        k = 'clientHeight',
        E = 'clientWidth';
      b === lt(n) && 'static' !== _t((b = bt(n))).position && ((k = 'scrollHeight'), (E = 'scrollWidth')),
        (b = b),
        s === q && ((_ = K), (p -= b[k] - i.height), (p *= a ? 1 : -1)),
        s === X && ((v = G), (d -= b[E] - i.width), (d *= a ? 1 : -1));
    }

    var w,
      A = Object.assign(
        {
          position: o,
        },
        u && Bt
      );
    return a
      ? Object.assign(
          {},
          A,
          (((w = {})[_] = m ? '0' : ''),
          (w[v] = g ? '0' : ''),
          (w.transform =
            (y.devicePixelRatio || 1) < 2
              ? 'translate(' + d + 'px, ' + p + 'px)'
              : 'translate3d(' + d + 'px, ' + p + 'px, 0)'),
          w)
        )
      : Object.assign({}, A, (((e = {})[_] = m ? p + 'px' : ''), (e[v] = g ? d + 'px' : ''), (e.transform = ''), e));
  }

  var Mt = {
      name: 'computeStyles',
      enabled: !0,
      phase: 'beforeWrite',
      fn: function(t) {
        var e = t.state,
          n = t.options,
          i = n.gpuAcceleration,
          s = void 0 === i || i,
          r = n.adaptive,
          o = void 0 === r || r,
          a = n.roundOffsets,
          u = void 0 === a || a,
          l = {
            placement: pt(e.placement),
            popper: e.elements.popper,
            popperRect: e.rects.popper,
            gpuAcceleration: s,
          };
        null != e.modifiersData.popperOffsets &&
          (e.styles.popper = Object.assign(
            {},
            e.styles.popper,
            Pt(
              Object.assign({}, l, {
                offsets: e.modifiersData.popperOffsets,
                position: e.options.strategy,
                adaptive: o,
                roundOffsets: u,
              })
            )
          )),
          null != e.modifiersData.arrow &&
            (e.styles.arrow = Object.assign(
              {},
              e.styles.arrow,
              Pt(
                Object.assign({}, l, {
                  offsets: e.modifiersData.arrow,
                  position: 'absolute',
                  adaptive: !1,
                  roundOffsets: u,
                })
              )
            )),
          (e.attributes.popper = Object.assign({}, e.attributes.popper, {
            'data-popper-placement': e.placement,
          }));
      },
      data: {},
    },
    It = {
      passive: !0,
    };
  var Nt = {
      name: 'eventListeners',
      enabled: !0,
      phase: 'write',
      fn: function() {},
      effect: function(t) {
        var e = t.state,
          n = t.instance,
          i = t.options,
          s = i.scroll,
          r = void 0 === s || s,
          o = i.resize,
          a = void 0 === o || o,
          u = lt(e.elements.popper),
          l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
        return (
          r &&
            l.forEach(function(t) {
              t.addEventListener('scroll', n.update, It);
            }),
          a && u.addEventListener('resize', n.update, It),
          function() {
            r &&
              l.forEach(function(t) {
                t.removeEventListener('scroll', n.update, It);
              }),
              a && u.removeEventListener('resize', n.update, It);
          }
        );
      },
      data: {},
    },
    Rt = {
      left: 'right',
      right: 'left',
      bottom: 'top',
      top: 'bottom',
    };

  function $t(t) {
    return t.replace(/left|right|bottom|top/g, function(t) {
      return Rt[t];
    });
  }

  var jt = {
    start: 'end',
    end: 'start',
  };

  function Vt(t) {
    return t.replace(/start|end/g, function(t) {
      return jt[t];
    });
  }

  function Ht(t) {
    var e = lt(t);
    return {
      scrollLeft: e.pageXOffset,
      scrollTop: e.pageYOffset,
    };
  }

  function Wt(t) {
    return gt(bt(t)).left + Ht(t).scrollLeft;
  }

  function zt(t) {
    var e = _t(t),
      n = e.overflow,
      i = e.overflowX,
      s = e.overflowY;

    return /auto|scroll|overlay|hidden/.test(n + s + i);
  }

  function Ut(t, e) {
    var n;
    void 0 === e && (e = []);

    var i = (function t(e) {
        return ['html', 'body', '#document'].indexOf(ut(e)) >= 0 ? e.ownerDocument.body : ht(e) && zt(e) ? e : t(kt(e));
      })(t),
      s = i === (null == (n = t.ownerDocument) ? void 0 : n.body),
      r = lt(i),
      o = s ? [r].concat(r.visualViewport || [], zt(i) ? i : []) : i,
      a = e.concat(o);

    return s ? a : a.concat(Ut(kt(o)));
  }

  function Yt(t) {
    return Object.assign({}, t, {
      left: t.x,
      top: t.y,
      right: t.x + t.width,
      bottom: t.y + t.height,
    });
  }

  function qt(t, e) {
    return e === nt
      ? Yt(
          (function(t) {
            var e = lt(t),
              n = bt(t),
              i = e.visualViewport,
              s = n.clientWidth,
              r = n.clientHeight,
              o = 0,
              a = 0;
            return (
              i &&
                ((s = i.width),
                (r = i.height),
                /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || ((o = i.offsetLeft), (a = i.offsetTop))),
              {
                width: s,
                height: r,
                x: o + Wt(t),
                y: a,
              }
            );
          })(t)
        )
      : ht(e)
      ? (function(t) {
          var e = gt(t);
          return (
            (e.top = e.top + t.clientTop),
            (e.left = e.left + t.clientLeft),
            (e.bottom = e.top + t.clientHeight),
            (e.right = e.left + t.clientWidth),
            (e.width = t.clientWidth),
            (e.height = t.clientHeight),
            (e.x = e.left),
            (e.y = e.top),
            e
          );
        })(e)
      : Yt(
          (function(t) {
            var e,
              n = bt(t),
              i = Ht(t),
              s = null == (e = t.ownerDocument) ? void 0 : e.body,
              r = Ct(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0),
              o = Ct(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0),
              a = -i.scrollLeft + Wt(t),
              u = -i.scrollTop;
            return (
              'rtl' === _t(s || n).direction && (a += Ct(n.clientWidth, s ? s.clientWidth : 0) - r),
              {
                width: r,
                height: o,
                x: a,
                y: u,
              }
            );
          })(bt(t))
        );
  }

  function Kt(t, e, n) {
    var i =
        'clippingParents' === e
          ? (function(t) {
              var e = Ut(kt(t)),
                n = ['absolute', 'fixed'].indexOf(_t(t).position) >= 0 && ht(t) ? wt(t) : t;
              return ct(n)
                ? e.filter(function(t) {
                    return ct(t) && vt(t, n) && 'body' !== ut(t);
                  })
                : [];
            })(t)
          : [].concat(e),
      s = [].concat(i, [n]),
      r = s[0],
      o = s.reduce(function(e, n) {
        var i = qt(t, n);
        return (
          (e.top = Ct(i.top, e.top)),
          (e.right = Tt(i.right, e.right)),
          (e.bottom = Tt(i.bottom, e.bottom)),
          (e.left = Ct(i.left, e.left)),
          e
        );
      }, qt(t, r));
    return (o.width = o.right - o.left), (o.height = o.bottom - o.top), (o.x = o.left), (o.y = o.top), o;
  }

  function Gt(t) {
    return t.split('-')[1];
  }

  function Xt(t) {
    var e,
      n = t.reference,
      i = t.element,
      s = t.placement,
      r = s ? pt(s) : null,
      o = s ? Gt(s) : null,
      a = n.x + n.width / 2 - i.width / 2,
      u = n.y + n.height / 2 - i.height / 2;

    switch (r) {
      case q:
        e = {
          x: a,
          y: n.y - i.height,
        };
        break;

      case K:
        e = {
          x: a,
          y: n.y + n.height,
        };
        break;

      case G:
        e = {
          x: n.x + n.width,
          y: u,
        };
        break;

      case X:
        e = {
          x: n.x - i.width,
          y: u,
        };
        break;

      default:
        e = {
          x: n.x,
          y: n.y,
        };
    }

    var l = r ? At(r) : null;

    if (null != l) {
      var c = 'y' === l ? 'height' : 'width';

      switch (o) {
        case J:
          e[l] = e[l] - (n[c] / 2 - i[c] / 2);
          break;

        case tt:
          e[l] = e[l] + (n[c] / 2 - i[c] / 2);
      }
    }

    return e;
  }

  function Qt(t, e) {
    void 0 === e && (e = {});
    var n = e,
      i = n.placement,
      s = void 0 === i ? t.placement : i,
      r = n.boundary,
      o = void 0 === r ? et : r,
      a = n.rootBoundary,
      u = void 0 === a ? nt : a,
      l = n.elementContext,
      c = void 0 === l ? it : l,
      h = n.altBoundary,
      d = void 0 !== h && h,
      f = n.padding,
      p = void 0 === f ? 0 : f,
      g = Ft('number' != typeof p ? p : Ot(p, Z)),
      m = c === it ? st : it,
      v = t.elements.reference,
      _ = t.rects.popper,
      y = t.elements[d ? m : c],
      b = Kt(ct(y) ? y : y.contextElement || bt(t.elements.popper), o, u),
      k = gt(v),
      E = Xt({
        reference: k,
        element: _,
        strategy: 'absolute',
        placement: s,
      }),
      w = Yt(Object.assign({}, _, E)),
      A = c === it ? w : k,
      C = {
        top: b.top - A.top + g.top,
        bottom: A.bottom - b.bottom + g.bottom,
        left: b.left - A.left + g.left,
        right: A.right - b.right + g.right,
      },
      T = t.modifiersData.offset;

    if (c === it && T) {
      var S = T[s];
      Object.keys(C).forEach(function(t) {
        var e = [G, K].indexOf(t) >= 0 ? 1 : -1,
          n = [q, K].indexOf(t) >= 0 ? 'y' : 'x';
        C[t] += S[n] * e;
      });
    }

    return C;
  }

  function Zt(t, e) {
    void 0 === e && (e = {});
    var n = e,
      i = n.placement,
      s = n.boundary,
      r = n.rootBoundary,
      o = n.padding,
      a = n.flipVariations,
      u = n.allowedAutoPlacements,
      l = void 0 === u ? ot : u,
      c = Gt(i),
      h = c
        ? a
          ? rt
          : rt.filter(function(t) {
              return Gt(t) === c;
            })
        : Z,
      d = h.filter(function(t) {
        return l.indexOf(t) >= 0;
      });
    0 === d.length && (d = h);
    var f = d.reduce(function(e, n) {
      return (
        (e[n] = Qt(t, {
          placement: n,
          boundary: s,
          rootBoundary: r,
          padding: o,
        })[pt(n)]),
        e
      );
    }, {});
    return Object.keys(f).sort(function(t, e) {
      return f[t] - f[e];
    });
  }

  var Jt = {
    name: 'flip',
    enabled: !0,
    phase: 'main',
    fn: function(t) {
      var e = t.state,
        n = t.options,
        i = t.name;

      if (!e.modifiersData[i]._skip) {
        for (
          var s = n.mainAxis,
            r = void 0 === s || s,
            o = n.altAxis,
            a = void 0 === o || o,
            u = n.fallbackPlacements,
            l = n.padding,
            c = n.boundary,
            h = n.rootBoundary,
            d = n.altBoundary,
            f = n.flipVariations,
            p = void 0 === f || f,
            g = n.allowedAutoPlacements,
            m = e.options.placement,
            v = pt(m),
            _ =
              u ||
              (v !== m && p
                ? (function(t) {
                    if (pt(t) === Q) return [];
                    var e = $t(t);
                    return [Vt(t), e, Vt(e)];
                  })(m)
                : [$t(m)]),
            y = [m].concat(_).reduce(function(t, n) {
              return t.concat(
                pt(n) === Q
                  ? Zt(e, {
                      placement: n,
                      boundary: c,
                      rootBoundary: h,
                      padding: l,
                      flipVariations: p,
                      allowedAutoPlacements: g,
                    })
                  : n
              );
            }, []),
            b = e.rects.reference,
            k = e.rects.popper,
            E = new Map(),
            w = !0,
            A = y[0],
            C = 0;
          C < y.length;
          C++
        ) {
          var T = y[C],
            S = pt(T),
            D = Gt(T) === J,
            F = [q, K].indexOf(S) >= 0,
            O = F ? 'width' : 'height',
            x = Qt(e, {
              placement: T,
              boundary: c,
              rootBoundary: h,
              altBoundary: d,
              padding: l,
            }),
            L = F ? (D ? G : X) : D ? K : q;
          b[O] > k[O] && (L = $t(L));
          var B = $t(L),
            P = [];

          if (
            (r && P.push(x[S] <= 0),
            a && P.push(x[L] <= 0, x[B] <= 0),
            P.every(function(t) {
              return t;
            }))
          ) {
            (A = T), (w = !1);
            break;
          }

          E.set(T, P);
        }

        if (w)
          for (
            var M = function(t) {
                var e = y.find(function(e) {
                  var n = E.get(e);
                  if (n)
                    return n.slice(0, t).every(function(t) {
                      return t;
                    });
                });
                if (e) return (A = e), 'break';
              },
              I = p ? 3 : 1;
            I > 0 && 'break' !== M(I);
            I--
          );
        e.placement !== A && ((e.modifiersData[i]._skip = !0), (e.placement = A), (e.reset = !0));
      }
    },
    requiresIfExists: ['offset'],
    data: {
      _skip: !1,
    },
  };

  function te(t, e, n) {
    return (
      void 0 === n &&
        (n = {
          x: 0,
          y: 0,
        }),
      {
        top: t.top - e.height - n.y,
        right: t.right - e.width + n.x,
        bottom: t.bottom - e.height + n.y,
        left: t.left - e.width - n.x,
      }
    );
  }

  function ee(t) {
    return [q, G, K, X].some(function(e) {
      return t[e] >= 0;
    });
  }

  var ne = {
    name: 'hide',
    enabled: !0,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: function(t) {
      var e = t.state,
        n = t.name,
        i = e.rects.reference,
        s = e.rects.popper,
        r = e.modifiersData.preventOverflow,
        o = Qt(e, {
          elementContext: 'reference',
        }),
        a = Qt(e, {
          altBoundary: !0,
        }),
        u = te(o, i),
        l = te(a, s, r),
        c = ee(u),
        h = ee(l);
      (e.modifiersData[n] = {
        referenceClippingOffsets: u,
        popperEscapeOffsets: l,
        isReferenceHidden: c,
        hasPopperEscaped: h,
      }),
        (e.attributes.popper = Object.assign({}, e.attributes.popper, {
          'data-popper-reference-hidden': c,
          'data-popper-escaped': h,
        }));
    },
  };
  var ie = {
    name: 'offset',
    enabled: !0,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: function(t) {
      var e = t.state,
        n = t.options,
        i = t.name,
        s = n.offset,
        r = void 0 === s ? [0, 0] : s,
        o = ot.reduce(function(t, n) {
          return (
            (t[n] = (function(t, e, n) {
              var i = pt(t),
                s = [X, q].indexOf(i) >= 0 ? -1 : 1,
                r =
                  'function' == typeof n
                    ? n(
                        Object.assign({}, e, {
                          placement: t,
                        })
                      )
                    : n,
                o = r[0],
                a = r[1];
              return (
                (o = o || 0),
                (a = (a || 0) * s),
                [X, G].indexOf(i) >= 0
                  ? {
                      x: a,
                      y: o,
                    }
                  : {
                      x: o,
                      y: a,
                    }
              );
            })(n, e.rects, r)),
            t
          );
        }, {}),
        a = o[e.placement],
        u = a.x,
        l = a.y;
      null != e.modifiersData.popperOffsets &&
        ((e.modifiersData.popperOffsets.x += u), (e.modifiersData.popperOffsets.y += l)),
        (e.modifiersData[i] = o);
    },
  };
  var se = {
    name: 'popperOffsets',
    enabled: !0,
    phase: 'read',
    fn: function(t) {
      var e = t.state,
        n = t.name;
      e.modifiersData[n] = Xt({
        reference: e.rects.reference,
        element: e.rects.popper,
        strategy: 'absolute',
        placement: e.placement,
      });
    },
    data: {},
  };
  var re = {
    name: 'preventOverflow',
    enabled: !0,
    phase: 'main',
    fn: function(t) {
      var e = t.state,
        n = t.options,
        i = t.name,
        s = n.mainAxis,
        r = void 0 === s || s,
        o = n.altAxis,
        a = void 0 !== o && o,
        u = n.boundary,
        l = n.rootBoundary,
        c = n.altBoundary,
        h = n.padding,
        d = n.tether,
        f = void 0 === d || d,
        p = n.tetherOffset,
        g = void 0 === p ? 0 : p,
        m = Qt(e, {
          boundary: u,
          rootBoundary: l,
          padding: h,
          altBoundary: c,
        }),
        v = pt(e.placement),
        _ = Gt(e.placement),
        y = !_,
        b = At(v),
        k = 'x' === b ? 'y' : 'x',
        E = e.modifiersData.popperOffsets,
        w = e.rects.reference,
        A = e.rects.popper,
        C =
          'function' == typeof g
            ? g(
                Object.assign({}, e.rects, {
                  placement: e.placement,
                })
              )
            : g,
        T = {
          x: 0,
          y: 0,
        };

      if (E) {
        if (r || a) {
          var S = 'y' === b ? q : X,
            D = 'y' === b ? K : G,
            F = 'y' === b ? 'height' : 'width',
            O = E[b],
            x = E[b] + m[S],
            L = E[b] - m[D],
            B = f ? -A[F] / 2 : 0,
            P = _ === J ? w[F] : A[F],
            M = _ === J ? -A[F] : -w[F],
            I = e.elements.arrow,
            N =
              f && I
                ? mt(I)
                : {
                    width: 0,
                    height: 0,
                  },
            R = e.modifiersData['arrow#persistent']
              ? e.modifiersData['arrow#persistent'].padding
              : {
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                },
            $ = R[S],
            j = R[D],
            V = Dt(0, w[F], N[F]),
            H = y ? w[F] / 2 - B - V - $ - C : P - V - $ - C,
            W = y ? -w[F] / 2 + B + V + j + C : M + V + j + C,
            z = e.elements.arrow && wt(e.elements.arrow),
            U = z ? ('y' === b ? z.clientTop || 0 : z.clientLeft || 0) : 0,
            Y = e.modifiersData.offset ? e.modifiersData.offset[e.placement][b] : 0,
            Q = E[b] + H - Y - U,
            Z = E[b] + W - Y;

          if (r) {
            var tt = Dt(f ? Tt(x, Q) : x, O, f ? Ct(L, Z) : L);
            (E[b] = tt), (T[b] = tt - O);
          }

          if (a) {
            var et = 'x' === b ? q : X,
              nt = 'x' === b ? K : G,
              it = E[k],
              st = it + m[et],
              rt = it - m[nt],
              ot = Dt(f ? Tt(st, Q) : st, it, f ? Ct(rt, Z) : rt);
            (E[k] = ot), (T[k] = ot - it);
          }
        }

        e.modifiersData[i] = T;
      }
    },
    requiresIfExists: ['offset'],
  };

  function oe(t, e, n) {
    void 0 === n && (n = !1);
    var i,
      s,
      r = bt(e),
      o = gt(t),
      a = ht(e),
      u = {
        scrollLeft: 0,
        scrollTop: 0,
      },
      l = {
        x: 0,
        y: 0,
      };
    return (
      (a || (!a && !n)) &&
        (('body' !== ut(e) || zt(r)) &&
          (u =
            (i = e) !== lt(i) && ht(i)
              ? {
                  scrollLeft: (s = i).scrollLeft,
                  scrollTop: s.scrollTop,
                }
              : Ht(i)),
        ht(e) ? (((l = gt(e)).x += e.clientLeft), (l.y += e.clientTop)) : r && (l.x = Wt(r))),
      {
        x: o.left + u.scrollLeft - l.x,
        y: o.top + u.scrollTop - l.y,
        width: o.width,
        height: o.height,
      }
    );
  }

  function ae(t) {
    var e = new Map(),
      n = new Set(),
      i = [];
    return (
      t.forEach(function(t) {
        e.set(t.name, t);
      }),
      t.forEach(function(t) {
        n.has(t.name) ||
          (function t(s) {
            n.add(s.name),
              [].concat(s.requires || [], s.requiresIfExists || []).forEach(function(i) {
                if (!n.has(i)) {
                  var s = e.get(i);
                  s && t(s);
                }
              }),
              i.push(s);
          })(t);
      }),
      i
    );
  }

  var ue = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute',
  };

  function le() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];

    return !e.some(function(t) {
      return !(t && 'function' == typeof t.getBoundingClientRect);
    });
  }

  function ce(t) {
    void 0 === t && (t = {});
    var e = t,
      n = e.defaultModifiers,
      i = void 0 === n ? [] : n,
      s = e.defaultOptions,
      r = void 0 === s ? ue : s;
    return function(t, e, n) {
      void 0 === n && (n = r);
      var s,
        o,
        a = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, ue, r),
          modifiersData: {},
          elements: {
            reference: t,
            popper: e,
          },
          attributes: {},
          styles: {},
        },
        u = [],
        l = !1,
        c = {
          state: a,
          setOptions: function(n) {
            h(),
              (a.options = Object.assign({}, r, a.options, n)),
              (a.scrollParents = {
                reference: ct(t) ? Ut(t) : t.contextElement ? Ut(t.contextElement) : [],
                popper: Ut(e),
              });

            var s,
              o,
              l = (function(t) {
                var e = ae(t);
                return at.reduce(function(t, n) {
                  return t.concat(
                    e.filter(function(t) {
                      return t.phase === n;
                    })
                  );
                }, []);
              })(
                ((s = [].concat(i, a.options.modifiers)),
                (o = s.reduce(function(t, e) {
                  var n = t[e.name];
                  return (
                    (t[e.name] = n
                      ? Object.assign({}, n, e, {
                          options: Object.assign({}, n.options, e.options),
                          data: Object.assign({}, n.data, e.data),
                        })
                      : e),
                    t
                  );
                }, {})),
                Object.keys(o).map(function(t) {
                  return o[t];
                }))
              );

            return (
              (a.orderedModifiers = l.filter(function(t) {
                return t.enabled;
              })),
              a.orderedModifiers.forEach(function(t) {
                var e = t.name,
                  n = t.options,
                  i = void 0 === n ? {} : n,
                  s = t.effect;

                if ('function' == typeof s) {
                  var r = s({
                    state: a,
                    name: e,
                    instance: c,
                    options: i,
                  });
                  u.push(r || function() {});
                }
              }),
              c.update()
            );
          },
          forceUpdate: function() {
            if (!l) {
              var t = a.elements,
                e = t.reference,
                n = t.popper;

              if (le(e, n)) {
                (a.rects = {
                  reference: oe(e, wt(n), 'fixed' === a.options.strategy),
                  popper: mt(n),
                }),
                  (a.reset = !1),
                  (a.placement = a.options.placement),
                  a.orderedModifiers.forEach(function(t) {
                    return (a.modifiersData[t.name] = Object.assign({}, t.data));
                  });

                for (var i = 0; i < a.orderedModifiers.length; i++)
                  if (!0 !== a.reset) {
                    var s = a.orderedModifiers[i],
                      r = s.fn,
                      o = s.options,
                      u = void 0 === o ? {} : o,
                      h = s.name;
                    'function' == typeof r &&
                      (a =
                        r({
                          state: a,
                          options: u,
                          name: h,
                          instance: c,
                        }) || a);
                  } else (a.reset = !1), (i = -1);
              }
            }
          },
          update:
            ((s = function() {
              return new Promise(function(t) {
                c.forceUpdate(), t(a);
              });
            }),
            function() {
              return (
                o ||
                  (o = new Promise(function(t) {
                    Promise.resolve().then(function() {
                      (o = void 0), t(s());
                    });
                  })),
                o
              );
            }),
          destroy: function() {
            h(), (l = !0);
          },
        };
      if (!le(t, e)) return c;

      function h() {
        u.forEach(function(t) {
          return t();
        }),
          (u = []);
      }

      return (
        c.setOptions(n).then(function(t) {
          !l && n.onFirstUpdate && n.onFirstUpdate(t);
        }),
        c
      );
    };
  }

  var he = ce(),
    de = ce({
      defaultModifiers: [Nt, se, Mt, ft],
    }),
    fe = ce({
      defaultModifiers: [Nt, se, Mt, ft, ie, Jt, re, Lt, ne],
    }),
    pe = Object.freeze({
      __proto__: null,
      popperGenerator: ce,
      detectOverflow: Qt,
      createPopperBase: he,
      createPopper: fe,
      createPopperLite: de,
      top: q,
      bottom: K,
      right: G,
      left: X,
      auto: Q,
      basePlacements: Z,
      start: J,
      end: tt,
      clippingParents: et,
      viewport: nt,
      popper: it,
      reference: st,
      variationPlacements: rt,
      placements: ot,
      beforeRead: 'beforeRead',
      read: 'read',
      afterRead: 'afterRead',
      beforeMain: 'beforeMain',
      main: 'main',
      afterMain: 'afterMain',
      beforeWrite: 'beforeWrite',
      write: 'write',
      afterWrite: 'afterWrite',
      modifierPhases: at,
      applyStyles: ft,
      arrow: Lt,
      computeStyles: Mt,
      eventListeners: Nt,
      flip: Jt,
      hide: ne,
      offset: ie,
      popperOffsets: se,
      preventOverflow: re,
    });

  const ge = 'transitionend',
    me = t => {
      do {
        t += Math.floor(1e6 * Math.random());
      } while (document.getElementById(t));

      return t;
    },
    ve = t => {
      let e = t.getAttribute('data-bs-target');

      if (!e || '#' === e) {
        let n = t.getAttribute('href');
        if (!n || (!n.includes('#') && !n.startsWith('.'))) return null;
        n.includes('#') && !n.startsWith('#') && (n = '#' + n.split('#')[1]), (e = n && '#' !== n ? n.trim() : null);
      }

      return e;
    },
    _e = t => {
      const e = ve(t);
      return e && document.querySelector(e) ? e : null;
    },
    ye = t => {
      const e = ve(t);
      return e ? document.querySelector(e) : null;
    },
    be = t => {
      if (!t) return 0;
      let { transitionDuration: e, transitionDelay: n } = window.getComputedStyle(t);
      const i = Number.parseFloat(e),
        s = Number.parseFloat(n);
      return i || s
        ? ((e = e.split(',')[0]), (n = n.split(',')[0]), 1e3 * (Number.parseFloat(e) + Number.parseFloat(n)))
        : 0;
    },
    ke = t => {
      t.dispatchEvent(new Event(ge));
    },
    Ee = t => (t[0] || t).nodeType,
    we = (t, e) => {
      let n = !1;
      const i = e + 5;
      t.addEventListener(ge, function e() {
        (n = !0), t.removeEventListener(ge, e);
      }),
        setTimeout(() => {
          n || ke(t);
        }, i);
    },
    Ae = (t, e, n) => {
      Object.keys(n).forEach(i => {
        const s = n[i],
          r = e[i],
          o =
            r && Ee(r)
              ? 'element'
              : (t =>
                  null == t
                    ? `${t}`
                    : {}.toString
                        .call(t)
                        .match(/\s([a-z]+)/i)[1]
                        .toLowerCase())(r);
        if (!new RegExp(s).test(o))
          throw new TypeError(
            `${t.toUpperCase()}: ` + `Option "${i}" provided type "${o}" ` + `but expected type "${s}".`
          );
      });
    },
    Ce = t => {
      if (!t) return !1;

      if (t.style && t.parentNode && t.parentNode.style) {
        const e = getComputedStyle(t),
          n = getComputedStyle(t.parentNode);
        return 'none' !== e.display && 'none' !== n.display && 'hidden' !== e.visibility;
      }

      return !1;
    },
    Te = t =>
      !t ||
      t.nodeType !== Node.ELEMENT_NODE ||
      !!t.classList.contains('disabled') ||
      (void 0 !== t.disabled ? t.disabled : t.hasAttribute('disabled') && 'false' !== t.getAttribute('disabled')),
    Se = t => {
      if (!document.documentElement.attachShadow) return null;

      if ('function' == typeof t.getRootNode) {
        const e = t.getRootNode();
        return e instanceof ShadowRoot ? e : null;
      }

      return t instanceof ShadowRoot ? t : t.parentNode ? Se(t.parentNode) : null;
    },
    De = () => function() {},
    Fe = t => t.offsetHeight,
    Oe = () => {
      const { jQuery: t } = window;
      return t && !document.body.hasAttribute('data-bs-no-jquery') ? t : null;
    },
    xe = () => 'rtl' === document.documentElement.dir,
    Le = (t, e) => {
      (t => {
        'loading' === document.readyState ? document.addEventListener('DOMContentLoaded', t) : t();
      })(() => {
        const n = Oe();

        if (n) {
          const i = n.fn[t];
          (n.fn[t] = e.jQueryInterface),
            (n.fn[t].Constructor = e),
            (n.fn[t].noConflict = () => ((n.fn[t] = i), e.jQueryInterface));
        }
      });
    },
    Be = new Map();

  var Pe = {
    set(t, e, n) {
      Be.has(t) || Be.set(t, new Map());
      const i = Be.get(t);
      i.has(e) || 0 === i.size
        ? i.set(e, n)
        : console.error(
            `Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(i.keys())[0]}.`
          );
    },

    get: (t, e) => (Be.has(t) && Be.get(t).get(e)) || null,

    remove(t, e) {
      if (!Be.has(t)) return;
      const n = Be.get(t);
      n.delete(e), 0 === n.size && Be.delete(t);
    },
  };
  const Me = /[^.]*(?=\..*)\.|.*/,
    Ie = /\..*/,
    Ne = /::\d+$/,
    Re = {};
  let $e = 1;
  const je = {
      mouseenter: 'mouseover',
      mouseleave: 'mouseout',
    },
    Ve = new Set([
      'click',
      'dblclick',
      'mouseup',
      'mousedown',
      'contextmenu',
      'mousewheel',
      'DOMMouseScroll',
      'mouseover',
      'mouseout',
      'mousemove',
      'selectstart',
      'selectend',
      'keydown',
      'keypress',
      'keyup',
      'orientationchange',
      'touchstart',
      'touchmove',
      'touchend',
      'touchcancel',
      'pointerdown',
      'pointermove',
      'pointerup',
      'pointerleave',
      'pointercancel',
      'gesturestart',
      'gesturechange',
      'gestureend',
      'focus',
      'blur',
      'change',
      'reset',
      'select',
      'submit',
      'focusin',
      'focusout',
      'load',
      'unload',
      'beforeunload',
      'resize',
      'move',
      'DOMContentLoaded',
      'readystatechange',
      'error',
      'abort',
      'scroll',
    ]);

  function He(t, e) {
    return (e && `${e}::${$e++}`) || t.uidEvent || $e++;
  }

  function We(t) {
    const e = He(t);
    return (t.uidEvent = e), (Re[e] = Re[e] || {}), Re[e];
  }

  function ze(t, e, n = null) {
    const i = Object.keys(t);

    for (let s = 0, r = i.length; s < r; s++) {
      const r = t[i[s]];
      if (r.originalHandler === e && r.delegationSelector === n) return r;
    }

    return null;
  }

  function Ue(t, e, n) {
    const i = 'string' == typeof e,
      s = i ? n : e;
    let r = t.replace(Ie, '');
    const o = je[r];
    return o && (r = o), Ve.has(r) || (r = t), [i, s, r];
  }

  function Ye(t, e, n, i, s) {
    if ('string' != typeof e || !t) return;
    n || ((n = i), (i = null));
    const [r, o, a] = Ue(e, n, i),
      u = We(t),
      l = u[a] || (u[a] = {}),
      c = ze(l, o, r ? n : null);
    if (c) return void (c.oneOff = c.oneOff && s);
    const h = He(o, e.replace(Me, '')),
      d = r
        ? (function(t, e, n) {
            return function i(s) {
              const r = t.querySelectorAll(e);

              for (let { target: e } = s; e && e !== this; e = e.parentNode)
                for (let o = r.length; o--; )
                  if (r[o] === e) return (s.delegateTarget = e), i.oneOff && Ke.off(t, s.type, n), n.apply(e, [s]);

              return null;
            };
          })(t, n, i)
        : (function(t, e) {
            return function n(i) {
              return (i.delegateTarget = t), n.oneOff && Ke.off(t, i.type, e), e.apply(t, [i]);
            };
          })(t, n);
    (d.delegationSelector = r ? n : null),
      (d.originalHandler = o),
      (d.oneOff = s),
      (d.uidEvent = h),
      (l[h] = d),
      t.addEventListener(a, d, r);
  }

  function qe(t, e, n, i, s) {
    const r = ze(e[n], i, s);
    r && (t.removeEventListener(n, r, Boolean(s)), delete e[n][r.uidEvent]);
  }

  const Ke = {
      on(t, e, n, i) {
        Ye(t, e, n, i, !1);
      },

      one(t, e, n, i) {
        Ye(t, e, n, i, !0);
      },

      off(t, e, n, i) {
        if ('string' != typeof e || !t) return;
        const [s, r, o] = Ue(e, n, i),
          a = o !== e,
          u = We(t),
          l = e.startsWith('.');

        if (void 0 !== r) {
          if (!u || !u[o]) return;
          return void qe(t, u, o, r, s ? n : null);
        }

        l &&
          Object.keys(u).forEach(n => {
            !(function(t, e, n, i) {
              const s = e[n] || {};
              Object.keys(s).forEach(r => {
                if (r.includes(i)) {
                  const i = s[r];
                  qe(t, e, n, i.originalHandler, i.delegationSelector);
                }
              });
            })(t, u, n, e.slice(1));
          });
        const c = u[o] || {};
        Object.keys(c).forEach(n => {
          const i = n.replace(Ne, '');

          if (!a || e.includes(i)) {
            const e = c[n];
            qe(t, u, o, e.originalHandler, e.delegationSelector);
          }
        });
      },

      trigger(t, e, n) {
        if ('string' != typeof e || !t) return null;
        const i = Oe(),
          s = e.replace(Ie, ''),
          r = e !== s,
          o = Ve.has(s);
        let a,
          u = !0,
          l = !0,
          c = !1,
          h = null;
        return (
          r &&
            i &&
            ((a = i.Event(e, n)),
            i(t).trigger(a),
            (u = !a.isPropagationStopped()),
            (l = !a.isImmediatePropagationStopped()),
            (c = a.isDefaultPrevented())),
          o
            ? (h = document.createEvent('HTMLEvents')).initEvent(s, u, !0)
            : (h = new CustomEvent(e, {
                bubbles: u,
                cancelable: !0,
              })),
          void 0 !== n &&
            Object.keys(n).forEach(t => {
              Object.defineProperty(h, t, {
                get: () => n[t],
              });
            }),
          c && h.preventDefault(),
          l && t.dispatchEvent(h),
          h.defaultPrevented && void 0 !== a && a.preventDefault(),
          h
        );
      },
    },
    Ge = '5.0.0-beta3';

  class Xe {
    constructor(t) {
      (t = 'string' == typeof t ? document.querySelector(t) : t) &&
        ((this._element = t), Pe.set(this._element, this.constructor.DATA_KEY, this));
    }

    dispose() {
      Pe.remove(this._element, this.constructor.DATA_KEY), (this._element = null);
    }

    static getInstance(t) {
      return Pe.get(t, this.DATA_KEY);
    }

    static get VERSION() {
      return Ge;
    }
  }

  const Qe = 'bs.alert',
    Ze = `.${Qe}`,
    Je = `close${Ze}`,
    tn = `closed${Ze}`,
    en = `click${Ze}.data-api`,
    nn = 'alert',
    sn = 'fade',
    rn = 'show';

  class on extends Xe {
    static get DATA_KEY() {
      return Qe;
    }

    close(t) {
      const e = t ? this._getRootElement(t) : this._element,
        n = this._triggerCloseEvent(e);

      null === n || n.defaultPrevented || this._removeElement(e);
    }

    _getRootElement(t) {
      return ye(t) || t.closest(`.${nn}`);
    }

    _triggerCloseEvent(t) {
      return Ke.trigger(t, Je);
    }

    _removeElement(t) {
      if ((t.classList.remove(rn), !t.classList.contains(sn))) return void this._destroyElement(t);
      const e = be(t);
      Ke.one(t, 'transitionend', () => this._destroyElement(t)), we(t, e);
    }

    _destroyElement(t) {
      t.parentNode && t.parentNode.removeChild(t), Ke.trigger(t, tn);
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, Qe);
        e || (e = new on(this)), 'close' === t && e[t](this);
      });
    }

    static handleDismiss(t) {
      return function(e) {
        e && e.preventDefault(), t.close(this);
      };
    }
  }

  Ke.on(document, en, '[data-bs-dismiss="alert"]', on.handleDismiss(new on())), Le('alert', on);
  const an = 'bs.button',
    un = 'active',
    ln = `click${`.${an}`}.data-api`;

  class cn extends Xe {
    static get DATA_KEY() {
      return an;
    }

    toggle() {
      this._element.setAttribute('aria-pressed', this._element.classList.toggle(un));
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, an);
        e || (e = new cn(this)), 'toggle' === t && e[t]();
      });
    }
  }

  function hn(t) {
    return (
      'true' === t || ('false' !== t && (t === Number(t).toString() ? Number(t) : '' === t || 'null' === t ? null : t))
    );
  }

  function dn(t) {
    return t.replace(/[A-Z]/g, t => `-${t.toLowerCase()}`);
  }

  Ke.on(document, ln, '[data-bs-toggle="button"]', t => {
    t.preventDefault();
    const e = t.target.closest('[data-bs-toggle="button"]');
    let n = Pe.get(e, an);
    n || (n = new cn(e)), n.toggle();
  }),
    Le('button', cn);
  const fn = {
      setDataAttribute(t, e, n) {
        t.setAttribute(`data-bs-${dn(e)}`, n);
      },

      removeDataAttribute(t, e) {
        t.removeAttribute(`data-bs-${dn(e)}`);
      },

      getDataAttributes(t) {
        if (!t) return {};
        const e = {};
        return (
          Object.keys(t.dataset)
            .filter(t => t.startsWith('bs'))
            .forEach(n => {
              let i = n.replace(/^bs/, '');
              (i = i.charAt(0).toLowerCase() + i.slice(1, i.length)), (e[i] = hn(t.dataset[n]));
            }),
          e
        );
      },

      getDataAttribute: (t, e) => hn(t.getAttribute(`data-bs-${dn(e)}`)),

      offset(t) {
        const e = t.getBoundingClientRect();
        return {
          top: e.top + document.body.scrollTop,
          left: e.left + document.body.scrollLeft,
        };
      },

      position: t => ({
        top: t.offsetTop,
        left: t.offsetLeft,
      }),
    },
    pn = {
      find: (t, e = document.documentElement) => [].concat(...Element.prototype.querySelectorAll.call(e, t)),
      findOne: (t, e = document.documentElement) => Element.prototype.querySelector.call(e, t),
      children: (t, e) => [].concat(...t.children).filter(t => t.matches(e)),

      parents(t, e) {
        const n = [];
        let i = t.parentNode;

        for (; i && i.nodeType === Node.ELEMENT_NODE && 3 !== i.nodeType; )
          i.matches(e) && n.push(i), (i = i.parentNode);

        return n;
      },

      prev(t, e) {
        let n = t.previousElementSibling;

        for (; n; ) {
          if (n.matches(e)) return [n];
          n = n.previousElementSibling;
        }

        return [];
      },

      next(t, e) {
        let n = t.nextElementSibling;

        for (; n; ) {
          if (n.matches(e)) return [n];
          n = n.nextElementSibling;
        }

        return [];
      },
    },
    gn = 'carousel',
    mn = 'bs.carousel',
    vn = `.${mn}`,
    _n = 'ArrowLeft',
    yn = 'ArrowRight',
    bn = 500,
    kn = 40,
    En = {
      interval: 5e3,
      keyboard: !0,
      slide: !1,
      pause: 'hover',
      wrap: !0,
      touch: !0,
    },
    wn = {
      interval: '(number|boolean)',
      keyboard: 'boolean',
      slide: '(boolean|string)',
      pause: '(string|boolean)',
      wrap: 'boolean',
      touch: 'boolean',
    },
    An = 'next',
    Cn = 'prev',
    Tn = 'left',
    Sn = 'right',
    Dn = `slide${vn}`,
    Fn = `slid${vn}`,
    On = `keydown${vn}`,
    xn = `mouseenter${vn}`,
    Ln = `mouseleave${vn}`,
    Bn = `touchstart${vn}`,
    Pn = `touchmove${vn}`,
    Mn = `touchend${vn}`,
    In = `pointerdown${vn}`,
    Nn = `pointerup${vn}`,
    Rn = `dragstart${vn}`,
    $n = `load${vn}.data-api`,
    jn = `click${vn}.data-api`,
    Vn = 'carousel',
    Hn = 'active',
    Wn = 'slide',
    zn = 'carousel-item-end',
    Un = 'carousel-item-start',
    Yn = 'carousel-item-next',
    qn = 'carousel-item-prev',
    Kn = 'pointer-event',
    Gn = '.active',
    Xn = '.active.carousel-item',
    Qn = '.carousel-item',
    Zn = '.carousel-item img',
    Jn = '.carousel-item-next, .carousel-item-prev',
    ti = '.carousel-indicators',
    ei = '[data-bs-target]',
    ni = 'touch',
    ii = 'pen';

  class si extends Xe {
    constructor(t, e) {
      super(t),
        (this._items = null),
        (this._interval = null),
        (this._activeElement = null),
        (this._isPaused = !1),
        (this._isSliding = !1),
        (this.touchTimeout = null),
        (this.touchStartX = 0),
        (this.touchDeltaX = 0),
        (this._config = this._getConfig(e)),
        (this._indicatorsElement = pn.findOne(ti, this._element)),
        (this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0),
        (this._pointerEvent = Boolean(window.PointerEvent)),
        this._addEventListeners();
    }

    static get Default() {
      return En;
    }

    static get DATA_KEY() {
      return mn;
    }

    next() {
      this._isSliding || this._slide(An);
    }

    nextWhenVisible() {
      !document.hidden && Ce(this._element) && this.next();
    }

    prev() {
      this._isSliding || this._slide(Cn);
    }

    pause(t) {
      t || (this._isPaused = !0),
        pn.findOne(Jn, this._element) && (ke(this._element), this.cycle(!0)),
        clearInterval(this._interval),
        (this._interval = null);
    }

    cycle(t) {
      t || (this._isPaused = !1),
        this._interval && (clearInterval(this._interval), (this._interval = null)),
        this._config &&
          this._config.interval &&
          !this._isPaused &&
          (this._updateInterval(),
          (this._interval = setInterval(
            (document.visibilityState ? this.nextWhenVisible : this.next).bind(this),
            this._config.interval
          )));
    }

    to(t) {
      this._activeElement = pn.findOne(Xn, this._element);

      const e = this._getItemIndex(this._activeElement);

      if (t > this._items.length - 1 || t < 0) return;
      if (this._isSliding) return void Ke.one(this._element, Fn, () => this.to(t));
      if (e === t) return this.pause(), void this.cycle();
      const n = t > e ? An : Cn;

      this._slide(n, this._items[t]);
    }

    dispose() {
      Ke.off(this._element, vn),
        (this._items = null),
        (this._config = null),
        (this._interval = null),
        (this._isPaused = null),
        (this._isSliding = null),
        (this._activeElement = null),
        (this._indicatorsElement = null),
        super.dispose();
    }

    _getConfig(t) {
      return (t = { ...En, ...t }), Ae(gn, t, wn), t;
    }

    _handleSwipe() {
      const t = Math.abs(this.touchDeltaX);
      if (t <= kn) return;
      const e = t / this.touchDeltaX;
      (this.touchDeltaX = 0), e && this._slide(e > 0 ? Sn : Tn);
    }

    _addEventListeners() {
      this._config.keyboard && Ke.on(this._element, On, t => this._keydown(t)),
        'hover' === this._config.pause &&
          (Ke.on(this._element, xn, t => this.pause(t)), Ke.on(this._element, Ln, t => this.cycle(t))),
        this._config.touch && this._touchSupported && this._addTouchEventListeners();
    }

    _addTouchEventListeners() {
      const t = t => {
          !this._pointerEvent || (t.pointerType !== ii && t.pointerType !== ni)
            ? this._pointerEvent || (this.touchStartX = t.touches[0].clientX)
            : (this.touchStartX = t.clientX);
        },
        e = t => {
          this.touchDeltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this.touchStartX;
        },
        n = t => {
          !this._pointerEvent ||
            (t.pointerType !== ii && t.pointerType !== ni) ||
            (this.touchDeltaX = t.clientX - this.touchStartX),
            this._handleSwipe(),
            'hover' === this._config.pause &&
              (this.pause(),
              this.touchTimeout && clearTimeout(this.touchTimeout),
              (this.touchTimeout = setTimeout(t => this.cycle(t), bn + this._config.interval)));
        };

      pn.find(Zn, this._element).forEach(t => {
        Ke.on(t, Rn, t => t.preventDefault());
      }),
        this._pointerEvent
          ? (Ke.on(this._element, In, e => t(e)), Ke.on(this._element, Nn, t => n(t)), this._element.classList.add(Kn))
          : (Ke.on(this._element, Bn, e => t(e)),
            Ke.on(this._element, Pn, t => e(t)),
            Ke.on(this._element, Mn, t => n(t)));
    }

    _keydown(t) {
      /input|textarea/i.test(t.target.tagName) ||
        (t.key === _n ? (t.preventDefault(), this._slide(Tn)) : t.key === yn && (t.preventDefault(), this._slide(Sn)));
    }

    _getItemIndex(t) {
      return (this._items = t && t.parentNode ? pn.find(Qn, t.parentNode) : []), this._items.indexOf(t);
    }

    _getItemByOrder(t, e) {
      const n = t === An,
        i = t === Cn,
        s = this._getItemIndex(e),
        r = this._items.length - 1;

      if (((i && 0 === s) || (n && s === r)) && !this._config.wrap) return e;
      const o = (s + (i ? -1 : 1)) % this._items.length;
      return -1 === o ? this._items[this._items.length - 1] : this._items[o];
    }

    _triggerSlideEvent(t, e) {
      const n = this._getItemIndex(t),
        i = this._getItemIndex(pn.findOne(Xn, this._element));

      return Ke.trigger(this._element, Dn, {
        relatedTarget: t,
        direction: e,
        from: i,
        to: n,
      });
    }

    _setActiveIndicatorElement(t) {
      if (this._indicatorsElement) {
        const e = pn.findOne(Gn, this._indicatorsElement);
        e.classList.remove(Hn), e.removeAttribute('aria-current');
        const n = pn.find(ei, this._indicatorsElement);

        for (let e = 0; e < n.length; e++)
          if (Number.parseInt(n[e].getAttribute('data-bs-slide-to'), 10) === this._getItemIndex(t)) {
            n[e].classList.add(Hn), n[e].setAttribute('aria-current', 'true');
            break;
          }
      }
    }

    _updateInterval() {
      const t = this._activeElement || pn.findOne(Xn, this._element);
      if (!t) return;
      const e = Number.parseInt(t.getAttribute('data-bs-interval'), 10);
      e
        ? ((this._config.defaultInterval = this._config.defaultInterval || this._config.interval),
          (this._config.interval = e))
        : (this._config.interval = this._config.defaultInterval || this._config.interval);
    }

    _slide(t, e) {
      const n = this._directionToOrder(t),
        i = pn.findOne(Xn, this._element),
        s = this._getItemIndex(i),
        r = e || this._getItemByOrder(n, i),
        o = this._getItemIndex(r),
        a = Boolean(this._interval),
        u = n === An,
        l = u ? Un : zn,
        c = u ? Yn : qn,
        h = this._orderToDirection(n);

      if (r && r.classList.contains(Hn)) this._isSliding = !1;
      else if (!this._triggerSlideEvent(r, h).defaultPrevented && i && r) {
        if (
          ((this._isSliding = !0),
          a && this.pause(),
          this._setActiveIndicatorElement(r),
          (this._activeElement = r),
          this._element.classList.contains(Wn))
        ) {
          r.classList.add(c), Fe(r), i.classList.add(l), r.classList.add(l);
          const t = be(i);
          Ke.one(i, 'transitionend', () => {
            r.classList.remove(l, c),
              r.classList.add(Hn),
              i.classList.remove(Hn, c, l),
              (this._isSliding = !1),
              setTimeout(() => {
                Ke.trigger(this._element, Fn, {
                  relatedTarget: r,
                  direction: h,
                  from: s,
                  to: o,
                });
              }, 0);
          }),
            we(i, t);
        } else
          i.classList.remove(Hn),
            r.classList.add(Hn),
            (this._isSliding = !1),
            Ke.trigger(this._element, Fn, {
              relatedTarget: r,
              direction: h,
              from: s,
              to: o,
            });

        a && this.cycle();
      }
    }

    _directionToOrder(t) {
      return [Sn, Tn].includes(t) ? (xe() ? (t === Sn ? Cn : An) : t === Sn ? An : Cn) : t;
    }

    _orderToDirection(t) {
      return [An, Cn].includes(t) ? (xe() ? (t === An ? Tn : Sn) : t === An ? Sn : Tn) : t;
    }

    static carouselInterface(t, e) {
      let n = Pe.get(t, mn),
        i = { ...En, ...fn.getDataAttributes(t) };
      'object' == typeof e && (i = { ...i, ...e });
      const s = 'string' == typeof e ? e : i.slide;
      if ((n || (n = new si(t, i)), 'number' == typeof e)) n.to(e);
      else if ('string' == typeof s) {
        if (void 0 === n[s]) throw new TypeError(`No method named "${s}"`);
        n[s]();
      } else i.interval && i.ride && (n.pause(), n.cycle());
    }

    static jQueryInterface(t) {
      return this.each(function() {
        si.carouselInterface(this, t);
      });
    }

    static dataApiClickHandler(t) {
      const e = ye(this);
      if (!e || !e.classList.contains(Vn)) return;
      const n = { ...fn.getDataAttributes(e), ...fn.getDataAttributes(this) },
        i = this.getAttribute('data-bs-slide-to');
      i && (n.interval = !1), si.carouselInterface(e, n), i && Pe.get(e, mn).to(i), t.preventDefault();
    }
  }

  Ke.on(document, jn, '[data-bs-slide], [data-bs-slide-to]', si.dataApiClickHandler),
    Ke.on(window, $n, () => {
      const t = pn.find('[data-bs-ride="carousel"]');

      for (let e = 0, n = t.length; e < n; e++) si.carouselInterface(t[e], Pe.get(t[e], mn));
    }),
    Le(gn, si);
  const ri = 'collapse',
    oi = 'bs.collapse',
    ai = `.${oi}`,
    ui = {
      toggle: !0,
      parent: '',
    },
    li = {
      toggle: 'boolean',
      parent: '(string|element)',
    },
    ci = `show${ai}`,
    hi = `shown${ai}`,
    di = `hide${ai}`,
    fi = `hidden${ai}`,
    pi = `click${ai}.data-api`,
    gi = 'show',
    mi = 'collapse',
    vi = 'collapsing',
    _i = 'collapsed',
    yi = 'width',
    bi = 'height',
    ki = '.show, .collapsing',
    Ei = '[data-bs-toggle="collapse"]';

  class wi extends Xe {
    constructor(t, e) {
      super(t),
        (this._isTransitioning = !1),
        (this._config = this._getConfig(e)),
        (this._triggerArray = pn.find(
          `${Ei}[href="#${this._element.id}"],` + `${Ei}[data-bs-target="#${this._element.id}"]`
        ));
      const n = pn.find(Ei);

      for (let t = 0, e = n.length; t < e; t++) {
        const e = n[t],
          i = _e(e),
          s = pn.find(i).filter(t => t === this._element);

        null !== i && s.length && ((this._selector = i), this._triggerArray.push(e));
      }

      (this._parent = this._config.parent ? this._getParent() : null),
        this._config.parent || this._addAriaAndCollapsedClass(this._element, this._triggerArray),
        this._config.toggle && this.toggle();
    }

    static get Default() {
      return ui;
    }

    static get DATA_KEY() {
      return oi;
    }

    toggle() {
      this._element.classList.contains(gi) ? this.hide() : this.show();
    }

    show() {
      if (this._isTransitioning || this._element.classList.contains(gi)) return;
      let t, e;
      this._parent &&
        0 ===
          (t = pn
            .find(ki, this._parent)
            .filter(t =>
              'string' == typeof this._config.parent
                ? t.getAttribute('data-bs-parent') === this._config.parent
                : t.classList.contains(mi)
            )).length &&
        (t = null);
      const n = pn.findOne(this._selector);

      if (t) {
        const i = t.find(t => n !== t);
        if ((e = i ? Pe.get(i, oi) : null) && e._isTransitioning) return;
      }

      if (Ke.trigger(this._element, ci).defaultPrevented) return;
      t &&
        t.forEach(t => {
          n !== t && wi.collapseInterface(t, 'hide'), e || Pe.set(t, oi, null);
        });

      const i = this._getDimension();

      this._element.classList.remove(mi),
        this._element.classList.add(vi),
        (this._element.style[i] = 0),
        this._triggerArray.length &&
          this._triggerArray.forEach(t => {
            t.classList.remove(_i), t.setAttribute('aria-expanded', !0);
          }),
        this.setTransitioning(!0);
      const s = `scroll${i[0].toUpperCase() + i.slice(1)}`,
        r = be(this._element);
      Ke.one(this._element, 'transitionend', () => {
        this._element.classList.remove(vi),
          this._element.classList.add(mi, gi),
          (this._element.style[i] = ''),
          this.setTransitioning(!1),
          Ke.trigger(this._element, hi);
      }),
        we(this._element, r),
        (this._element.style[i] = `${this._element[s]}px`);
    }

    hide() {
      if (this._isTransitioning || !this._element.classList.contains(gi)) return;
      if (Ke.trigger(this._element, di).defaultPrevented) return;

      const t = this._getDimension();

      (this._element.style[t] = `${this._element.getBoundingClientRect()[t]}px`),
        Fe(this._element),
        this._element.classList.add(vi),
        this._element.classList.remove(mi, gi);
      const e = this._triggerArray.length;
      if (e > 0)
        for (let t = 0; t < e; t++) {
          const e = this._triggerArray[t],
            n = ye(e);
          n && !n.classList.contains(gi) && (e.classList.add(_i), e.setAttribute('aria-expanded', !1));
        }
      this.setTransitioning(!0);
      this._element.style[t] = '';
      const n = be(this._element);
      Ke.one(this._element, 'transitionend', () => {
        this.setTransitioning(!1),
          this._element.classList.remove(vi),
          this._element.classList.add(mi),
          Ke.trigger(this._element, fi);
      }),
        we(this._element, n);
    }

    setTransitioning(t) {
      this._isTransitioning = t;
    }

    dispose() {
      super.dispose(),
        (this._config = null),
        (this._parent = null),
        (this._triggerArray = null),
        (this._isTransitioning = null);
    }

    _getConfig(t) {
      return ((t = { ...ui, ...t }).toggle = Boolean(t.toggle)), Ae(ri, t, li), t;
    }

    _getDimension() {
      return this._element.classList.contains(yi) ? yi : bi;
    }

    _getParent() {
      let { parent: t } = this._config;
      Ee(t) ? (void 0 === t.jquery && void 0 === t[0]) || (t = t[0]) : (t = pn.findOne(t));
      const e = `${Ei}[data-bs-parent="${t}"]`;
      return (
        pn.find(e, t).forEach(t => {
          const e = ye(t);

          this._addAriaAndCollapsedClass(e, [t]);
        }),
        t
      );
    }

    _addAriaAndCollapsedClass(t, e) {
      if (!t || !e.length) return;
      const n = t.classList.contains(gi);
      e.forEach(t => {
        n ? t.classList.remove(_i) : t.classList.add(_i), t.setAttribute('aria-expanded', n);
      });
    }

    static collapseInterface(t, e) {
      let n = Pe.get(t, oi);
      const i = { ...ui, ...fn.getDataAttributes(t), ...('object' == typeof e && e ? e : {}) };

      if (
        (!n && i.toggle && 'string' == typeof e && /show|hide/.test(e) && (i.toggle = !1),
        n || (n = new wi(t, i)),
        'string' == typeof e)
      ) {
        if (void 0 === n[e]) throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    }

    static jQueryInterface(t) {
      return this.each(function() {
        wi.collapseInterface(this, t);
      });
    }
  }

  Ke.on(document, pi, Ei, function(t) {
    ('A' === t.target.tagName || (t.delegateTarget && 'A' === t.delegateTarget.tagName)) && t.preventDefault();

    const e = fn.getDataAttributes(this),
      n = _e(this);

    pn.find(n).forEach(t => {
      const n = Pe.get(t, oi);
      let i;
      n
        ? (null === n._parent &&
            'string' == typeof e.parent &&
            ((n._config.parent = e.parent), (n._parent = n._getParent())),
          (i = 'toggle'))
        : (i = e),
        wi.collapseInterface(t, i);
    });
  }),
    Le(ri, wi);
  const Ai = 'dropdown',
    Ci = 'bs.dropdown',
    Ti = `.${Ci}`,
    Si = 'Escape',
    Di = 'Space',
    Fi = 'Tab',
    Oi = 'ArrowUp',
    xi = 'ArrowDown',
    Li = 2,
    Bi = new RegExp(`${Oi}|${xi}|${Si}`),
    Pi = `hide${Ti}`,
    Mi = `hidden${Ti}`,
    Ii = `show${Ti}`,
    Ni = `shown${Ti}`,
    Ri = `click${Ti}`,
    $i = `click${Ti}.data-api`,
    ji = `keydown${Ti}.data-api`,
    Vi = `keyup${Ti}.data-api`,
    Hi = 'disabled',
    Wi = 'show',
    zi = 'dropup',
    Ui = 'dropend',
    Yi = 'dropstart',
    qi = 'navbar',
    Ki = '[data-bs-toggle="dropdown"]',
    Gi = '.dropdown-menu',
    Xi = '.navbar-nav',
    Qi = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)',
    Zi = xe() ? 'top-end' : 'top-start',
    Ji = xe() ? 'top-start' : 'top-end',
    ts = xe() ? 'bottom-end' : 'bottom-start',
    es = xe() ? 'bottom-start' : 'bottom-end',
    ns = xe() ? 'left-start' : 'right-start',
    is = xe() ? 'right-start' : 'left-start',
    ss = {
      offset: [0, 2],
      boundary: 'clippingParents',
      reference: 'toggle',
      display: 'dynamic',
      popperConfig: null,
    },
    rs = {
      offset: '(array|string|function)',
      boundary: '(string|element)',
      reference: '(string|element|object)',
      display: 'string',
      popperConfig: '(null|object|function)',
    };

  class os extends Xe {
    constructor(t, e) {
      super(t),
        (this._popper = null),
        (this._config = this._getConfig(e)),
        (this._menu = this._getMenuElement()),
        (this._inNavbar = this._detectNavbar()),
        this._addEventListeners();
    }

    static get Default() {
      return ss;
    }

    static get DefaultType() {
      return rs;
    }

    static get DATA_KEY() {
      return Ci;
    }

    toggle() {
      if (this._element.disabled || this._element.classList.contains(Hi)) return;

      const t = this._element.classList.contains(Wi);

      os.clearMenus(), t || this.show();
    }

    show() {
      if (this._element.disabled || this._element.classList.contains(Hi) || this._menu.classList.contains(Wi)) return;
      const t = os.getParentFromElement(this._element),
        e = {
          relatedTarget: this._element,
        };

      if (!Ke.trigger(this._element, Ii, e).defaultPrevented) {
        if (this._inNavbar) fn.setDataAttribute(this._menu, 'popper', 'none');
        else {
          if (void 0 === pe) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
          let e = this._element;
          'parent' === this._config.reference
            ? (e = t)
            : Ee(this._config.reference)
            ? ((e = this._config.reference),
              void 0 !== this._config.reference.jquery && (e = this._config.reference[0]))
            : 'object' == typeof this._config.reference && (e = this._config.reference);

          const n = this._getPopperConfig(),
            i = n.modifiers.find(t => 'applyStyles' === t.name && !1 === t.enabled);

          (this._popper = fe(e, this._menu, n)), i && fn.setDataAttribute(this._menu, 'popper', 'static');
        }
        'ontouchstart' in document.documentElement &&
          !t.closest(Xi) &&
          [].concat(...document.body.children).forEach(t => Ke.on(t, 'mouseover', null, De())),
          this._element.focus(),
          this._element.setAttribute('aria-expanded', !0),
          this._menu.classList.toggle(Wi),
          this._element.classList.toggle(Wi),
          Ke.trigger(this._element, Ni, e);
      }
    }

    hide() {
      if (this._element.disabled || this._element.classList.contains(Hi) || !this._menu.classList.contains(Wi)) return;
      const t = {
        relatedTarget: this._element,
      };
      Ke.trigger(this._element, Pi, t).defaultPrevented ||
        (this._popper && this._popper.destroy(),
        this._menu.classList.toggle(Wi),
        this._element.classList.toggle(Wi),
        fn.removeDataAttribute(this._menu, 'popper'),
        Ke.trigger(this._element, Mi, t));
    }

    dispose() {
      Ke.off(this._element, Ti),
        (this._menu = null),
        this._popper && (this._popper.destroy(), (this._popper = null)),
        super.dispose();
    }

    update() {
      (this._inNavbar = this._detectNavbar()), this._popper && this._popper.update();
    }

    _addEventListeners() {
      Ke.on(this._element, Ri, t => {
        t.preventDefault(), this.toggle();
      });
    }

    _getConfig(t) {
      if (
        ((t = { ...this.constructor.Default, ...fn.getDataAttributes(this._element), ...t }),
        Ae(Ai, t, this.constructor.DefaultType),
        'object' == typeof t.reference && !Ee(t.reference) && 'function' != typeof t.reference.getBoundingClientRect)
      )
        throw new TypeError(
          `${Ai.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`
        );
      return t;
    }

    _getMenuElement() {
      return pn.next(this._element, Gi)[0];
    }

    _getPlacement() {
      const t = this._element.parentNode;
      if (t.classList.contains(Ui)) return ns;
      if (t.classList.contains(Yi)) return is;
      const e =
        'end' ===
        getComputedStyle(this._menu)
          .getPropertyValue('--bs-position')
          .trim();
      return t.classList.contains(zi) ? (e ? Ji : Zi) : e ? es : ts;
    }

    _detectNavbar() {
      return null !== this._element.closest(`.${qi}`);
    }

    _getOffset() {
      const { offset: t } = this._config;
      return 'string' == typeof t
        ? t.split(',').map(t => Number.parseInt(t, 10))
        : 'function' == typeof t
        ? e => t(e, this._element)
        : t;
    }

    _getPopperConfig() {
      const t = {
        placement: this._getPlacement(),
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundary: this._config.boundary,
            },
          },
          {
            name: 'offset',
            options: {
              offset: this._getOffset(),
            },
          },
        ],
      };
      return (
        'static' === this._config.display &&
          (t.modifiers = [
            {
              name: 'applyStyles',
              enabled: !1,
            },
          ]),
        {
          ...t,
          ...('function' == typeof this._config.popperConfig
            ? this._config.popperConfig(t)
            : this._config.popperConfig),
        }
      );
    }

    static dropdownInterface(t, e) {
      let n = Pe.get(t, Ci);

      if ((n || (n = new os(t, 'object' == typeof e ? e : null)), 'string' == typeof e)) {
        if (void 0 === n[e]) throw new TypeError(`No method named "${e}"`);
        n[e]();
      }
    }

    static jQueryInterface(t) {
      return this.each(function() {
        os.dropdownInterface(this, t);
      });
    }

    static clearMenus(t) {
      if (t) {
        if (t.button === Li || ('keyup' === t.type && t.key !== Fi)) return;
        if (/input|select|textarea|form/i.test(t.target.tagName)) return;
      }

      const e = pn.find(Ki);

      for (let n = 0, i = e.length; n < i; n++) {
        const i = Pe.get(e[n], Ci),
          s = {
            relatedTarget: e[n],
          };
        if ((t && 'click' === t.type && (s.clickEvent = t), !i)) continue;
        const r = i._menu;

        if (e[n].classList.contains(Wi)) {
          if (t) {
            if ([i._element].some(e => t.composedPath().includes(e))) continue;
            if ('keyup' === t.type && t.key === Fi && r.contains(t.target)) continue;
          }

          Ke.trigger(e[n], Pi, s).defaultPrevented ||
            ('ontouchstart' in document.documentElement &&
              [].concat(...document.body.children).forEach(t => Ke.off(t, 'mouseover', null, De())),
            e[n].setAttribute('aria-expanded', 'false'),
            i._popper && i._popper.destroy(),
            r.classList.remove(Wi),
            e[n].classList.remove(Wi),
            fn.removeDataAttribute(r, 'popper'),
            Ke.trigger(e[n], Mi, s));
        }
      }
    }

    static getParentFromElement(t) {
      return ye(t) || t.parentNode;
    }

    static dataApiKeydownHandler(t) {
      if (
        /input|textarea/i.test(t.target.tagName)
          ? t.key === Di || (t.key !== Si && ((t.key !== xi && t.key !== Oi) || t.target.closest(Gi)))
          : !Bi.test(t.key)
      )
        return;
      if ((t.preventDefault(), t.stopPropagation(), this.disabled || this.classList.contains(Hi))) return;
      const e = os.getParentFromElement(this),
        n = this.classList.contains(Wi);

      if (t.key === Si) {
        return (this.matches(Ki) ? this : pn.prev(this, Ki)[0]).focus(), void os.clearMenus();
      }

      if (!n && (t.key === Oi || t.key === xi)) {
        return void (this.matches(Ki) ? this : pn.prev(this, Ki)[0]).click();
      }

      if (!n || t.key === Di) return void os.clearMenus();
      const i = pn.find(Qi, e).filter(Ce);
      if (!i.length) return;
      let s = i.indexOf(t.target);
      t.key === Oi && s > 0 && s--, t.key === xi && s < i.length - 1 && s++, i[(s = -1 === s ? 0 : s)].focus();
    }
  }

  Ke.on(document, ji, Ki, os.dataApiKeydownHandler),
    Ke.on(document, ji, Gi, os.dataApiKeydownHandler),
    Ke.on(document, $i, os.clearMenus),
    Ke.on(document, Vi, os.clearMenus),
    Ke.on(document, $i, Ki, function(t) {
      t.preventDefault(), os.dropdownInterface(this);
    }),
    Le(Ai, os);
  const as = 'modal',
    us = 'bs.modal',
    ls = `.${us}`,
    cs = 'Escape',
    hs = {
      backdrop: !0,
      keyboard: !0,
      focus: !0,
    },
    ds = {
      backdrop: '(boolean|string)',
      keyboard: 'boolean',
      focus: 'boolean',
    },
    fs = `hide${ls}`,
    ps = `hidePrevented${ls}`,
    gs = `hidden${ls}`,
    ms = `show${ls}`,
    vs = `shown${ls}`,
    _s = `focusin${ls}`,
    ys = `resize${ls}`,
    bs = `click.dismiss${ls}`,
    ks = `keydown.dismiss${ls}`,
    Es = `mouseup.dismiss${ls}`,
    ws = `mousedown.dismiss${ls}`,
    As = `click${ls}.data-api`,
    Cs = 'modal-scrollbar-measure',
    Ts = 'modal-backdrop',
    Ss = 'modal-open',
    Ds = 'fade',
    Fs = 'show',
    Os = 'modal-static',
    xs = '.modal-dialog',
    Ls = '.modal-body',
    Bs = '[data-bs-dismiss="modal"]',
    Ps = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    Ms = '.sticky-top';

  class Is extends Xe {
    constructor(t, e) {
      super(t),
        (this._config = this._getConfig(e)),
        (this._dialog = pn.findOne(xs, this._element)),
        (this._backdrop = null),
        (this._isShown = !1),
        (this._isBodyOverflowing = !1),
        (this._ignoreBackdropClick = !1),
        (this._isTransitioning = !1),
        (this._scrollbarWidth = 0);
    }

    static get Default() {
      return hs;
    }

    static get DATA_KEY() {
      return us;
    }

    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }

    show(t) {
      if (this._isShown || this._isTransitioning) return;
      this._isAnimated() && (this._isTransitioning = !0);
      const e = Ke.trigger(this._element, ms, {
        relatedTarget: t,
      });
      this._isShown ||
        e.defaultPrevented ||
        ((this._isShown = !0),
        this._checkScrollbar(),
        this._setScrollbar(),
        this._adjustDialog(),
        this._setEscapeEvent(),
        this._setResizeEvent(),
        Ke.on(this._element, bs, Bs, t => this.hide(t)),
        Ke.on(this._dialog, ws, () => {
          Ke.one(this._element, Es, t => {
            t.target === this._element && (this._ignoreBackdropClick = !0);
          });
        }),
        this._showBackdrop(() => this._showElement(t)));
    }

    hide(t) {
      if ((t && t.preventDefault(), !this._isShown || this._isTransitioning)) return;
      if (Ke.trigger(this._element, fs).defaultPrevented) return;
      this._isShown = !1;

      const e = this._isAnimated();

      if (
        (e && (this._isTransitioning = !0),
        this._setEscapeEvent(),
        this._setResizeEvent(),
        Ke.off(document, _s),
        this._element.classList.remove(Fs),
        Ke.off(this._element, bs),
        Ke.off(this._dialog, ws),
        e)
      ) {
        const t = be(this._element);
        Ke.one(this._element, 'transitionend', t => this._hideModal(t)), we(this._element, t);
      } else this._hideModal();
    }

    dispose() {
      [window, this._element, this._dialog].forEach(t => Ke.off(t, ls)),
        super.dispose(),
        Ke.off(document, _s),
        (this._config = null),
        (this._dialog = null),
        (this._backdrop = null),
        (this._isShown = null),
        (this._isBodyOverflowing = null),
        (this._ignoreBackdropClick = null),
        (this._isTransitioning = null),
        (this._scrollbarWidth = null);
    }

    handleUpdate() {
      this._adjustDialog();
    }

    _getConfig(t) {
      return (t = { ...hs, ...t }), Ae(as, t, ds), t;
    }

    _showElement(t) {
      const e = this._isAnimated(),
        n = pn.findOne(Ls, this._dialog);

      (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
        document.body.appendChild(this._element),
        (this._element.style.display = 'block'),
        this._element.removeAttribute('aria-hidden'),
        this._element.setAttribute('aria-modal', !0),
        this._element.setAttribute('role', 'dialog'),
        (this._element.scrollTop = 0),
        n && (n.scrollTop = 0),
        e && Fe(this._element),
        this._element.classList.add(Fs),
        this._config.focus && this._enforceFocus();

      const i = () => {
        this._config.focus && this._element.focus(),
          (this._isTransitioning = !1),
          Ke.trigger(this._element, vs, {
            relatedTarget: t,
          });
      };

      if (e) {
        const t = be(this._dialog);
        Ke.one(this._dialog, 'transitionend', i), we(this._dialog, t);
      } else i();
    }

    _enforceFocus() {
      Ke.off(document, _s),
        Ke.on(document, _s, t => {
          document === t.target ||
            this._element === t.target ||
            this._element.contains(t.target) ||
            this._element.focus();
        });
    }

    _setEscapeEvent() {
      this._isShown
        ? Ke.on(this._element, ks, t => {
            this._config.keyboard && t.key === cs
              ? (t.preventDefault(), this.hide())
              : this._config.keyboard || t.key !== cs || this._triggerBackdropTransition();
          })
        : Ke.off(this._element, ks);
    }

    _setResizeEvent() {
      this._isShown ? Ke.on(window, ys, () => this._adjustDialog()) : Ke.off(window, ys);
    }

    _hideModal() {
      (this._element.style.display = 'none'),
        this._element.setAttribute('aria-hidden', !0),
        this._element.removeAttribute('aria-modal'),
        this._element.removeAttribute('role'),
        (this._isTransitioning = !1),
        this._showBackdrop(() => {
          document.body.classList.remove(Ss),
            this._resetAdjustments(),
            this._resetScrollbar(),
            Ke.trigger(this._element, gs);
        });
    }

    _removeBackdrop() {
      this._backdrop.parentNode.removeChild(this._backdrop), (this._backdrop = null);
    }

    _showBackdrop(t) {
      const e = this._isAnimated();

      if (this._isShown && this._config.backdrop) {
        if (
          ((this._backdrop = document.createElement('div')),
          (this._backdrop.className = Ts),
          e && this._backdrop.classList.add(Ds),
          document.body.appendChild(this._backdrop),
          Ke.on(this._element, bs, t => {
            this._ignoreBackdropClick
              ? (this._ignoreBackdropClick = !1)
              : t.target === t.currentTarget &&
                ('static' === this._config.backdrop ? this._triggerBackdropTransition() : this.hide());
          }),
          e && Fe(this._backdrop),
          this._backdrop.classList.add(Fs),
          !e)
        )
          return void t();
        const n = be(this._backdrop);
        Ke.one(this._backdrop, 'transitionend', t), we(this._backdrop, n);
      } else if (!this._isShown && this._backdrop) {
        this._backdrop.classList.remove(Fs);

        const n = () => {
          this._removeBackdrop(), t();
        };

        if (e) {
          const t = be(this._backdrop);
          Ke.one(this._backdrop, 'transitionend', n), we(this._backdrop, t);
        } else n();
      } else t();
    }

    _isAnimated() {
      return this._element.classList.contains(Ds);
    }

    _triggerBackdropTransition() {
      if (Ke.trigger(this._element, ps).defaultPrevented) return;
      const t = this._element.scrollHeight > document.documentElement.clientHeight;
      t || (this._element.style.overflowY = 'hidden'), this._element.classList.add(Os);
      const e = be(this._dialog);
      Ke.off(this._element, 'transitionend'),
        Ke.one(this._element, 'transitionend', () => {
          this._element.classList.remove(Os),
            t ||
              (Ke.one(this._element, 'transitionend', () => {
                this._element.style.overflowY = '';
              }),
              we(this._element, e));
        }),
        we(this._element, e),
        this._element.focus();
    }

    _adjustDialog() {
      const t = this._element.scrollHeight > document.documentElement.clientHeight;
      ((!this._isBodyOverflowing && t && !xe()) || (this._isBodyOverflowing && !t && xe())) &&
        (this._element.style.paddingLeft = `${this._scrollbarWidth}px`),
        ((this._isBodyOverflowing && !t && !xe()) || (!this._isBodyOverflowing && t && xe())) &&
          (this._element.style.paddingRight = `${this._scrollbarWidth}px`);
    }

    _resetAdjustments() {
      (this._element.style.paddingLeft = ''), (this._element.style.paddingRight = '');
    }

    _checkScrollbar() {
      const t = document.body.getBoundingClientRect();
      (this._isBodyOverflowing = Math.round(t.left + t.right) < window.innerWidth),
        (this._scrollbarWidth = this._getScrollbarWidth());
    }

    _setScrollbar() {
      this._isBodyOverflowing &&
        (this._setElementAttributes(Ps, 'paddingRight', t => t + this._scrollbarWidth),
        this._setElementAttributes(Ms, 'marginRight', t => t - this._scrollbarWidth),
        this._setElementAttributes('body', 'paddingRight', t => t + this._scrollbarWidth)),
        document.body.classList.add(Ss);
    }

    _setElementAttributes(t, e, n) {
      pn.find(t).forEach(t => {
        if (t !== document.body && window.innerWidth > t.clientWidth + this._scrollbarWidth) return;
        const i = t.style[e],
          s = window.getComputedStyle(t)[e];
        fn.setDataAttribute(t, e, i), (t.style[e] = n(Number.parseFloat(s)) + 'px');
      });
    }

    _resetScrollbar() {
      this._resetElementAttributes(Ps, 'paddingRight'),
        this._resetElementAttributes(Ms, 'marginRight'),
        this._resetElementAttributes('body', 'paddingRight');
    }

    _resetElementAttributes(t, e) {
      pn.find(t).forEach(t => {
        const n = fn.getDataAttribute(t, e);
        void 0 === n && t === document.body ? (t.style[e] = '') : (fn.removeDataAttribute(t, e), (t.style[e] = n));
      });
    }

    _getScrollbarWidth() {
      const t = document.createElement('div');
      (t.className = Cs), document.body.appendChild(t);
      const e = t.getBoundingClientRect().width - t.clientWidth;
      return document.body.removeChild(t), e;
    }

    static jQueryInterface(t, e) {
      return this.each(function() {
        let n = Pe.get(this, us);
        const i = { ...hs, ...fn.getDataAttributes(this), ...('object' == typeof t && t ? t : {}) };

        if ((n || (n = new Is(this, i)), 'string' == typeof t)) {
          if (void 0 === n[t]) throw new TypeError(`No method named "${t}"`);
          n[t](e);
        }
      });
    }
  }

  Ke.on(document, As, '[data-bs-toggle="modal"]', function(t) {
    const e = ye(this);
    ('A' !== this.tagName && 'AREA' !== this.tagName) || t.preventDefault(),
      Ke.one(e, ms, t => {
        t.defaultPrevented ||
          Ke.one(e, gs, () => {
            Ce(this) && this.focus();
          });
      });
    let n = Pe.get(e, us);

    if (!n) {
      const t = { ...fn.getDataAttributes(e), ...fn.getDataAttributes(this) };
      n = new Is(e, t);
    }

    n.toggle(this);
  }),
    Le(as, Is);

  const Ns = () => {
      const t = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - t);
    },
    Rs = (t = Ns()) => {
      (document.body.style.overflow = 'hidden'),
        $s('.fixed-top, .fixed-bottom, .is-fixed', 'paddingRight', e => e + t),
        $s('.sticky-top', 'marginRight', e => e - t),
        $s('body', 'paddingRight', e => e + t);
    },
    $s = (t, e, n) => {
      const i = Ns();
      pn.find(t).forEach(t => {
        if (t !== document.body && window.innerWidth > t.clientWidth + i) return;
        const s = t.style[e],
          r = window.getComputedStyle(t)[e];
        fn.setDataAttribute(t, e, s), (t.style[e] = n(Number.parseFloat(r)) + 'px');
      });
    },
    js = () => {
      (document.body.style.overflow = 'auto'),
        Vs('.fixed-top, .fixed-bottom, .is-fixed', 'paddingRight'),
        Vs('.sticky-top', 'marginRight'),
        Vs('body', 'paddingRight');
    },
    Vs = (t, e) => {
      pn.find(t).forEach(t => {
        const n = fn.getDataAttribute(t, e);
        void 0 === n && t === document.body
          ? t.style.removeProperty(e)
          : (fn.removeDataAttribute(t, e), (t.style[e] = n));
      });
    },
    Hs = 'offcanvas',
    Ws = 'bs.offcanvas',
    zs = `.${Ws}`,
    Us = `load${zs}.data-api`,
    Ys = 'Escape',
    qs = {
      backdrop: !0,
      keyboard: !0,
      scroll: !1,
    },
    Ks = {
      backdrop: 'boolean',
      keyboard: 'boolean',
      scroll: 'boolean',
    },
    Gs = 'offcanvas-backdrop',
    Xs = 'show',
    Qs = 'offcanvas-toggling',
    Zs = `.offcanvas.show, .${Qs}`,
    Js = `show${zs}`,
    tr = `shown${zs}`,
    er = `hide${zs}`,
    nr = `hidden${zs}`,
    ir = `focusin${zs}`,
    sr = `click${zs}.data-api`,
    rr = `click.dismiss${zs}`,
    or = '[data-bs-dismiss="offcanvas"]';

  class ar extends Xe {
    constructor(t, e) {
      super(t), (this._config = this._getConfig(e)), (this._isShown = !1), this._addEventListeners();
    }

    static get Default() {
      return qs;
    }

    static get DATA_KEY() {
      return Ws;
    }

    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }

    show(t) {
      if (this._isShown) return;
      if (
        Ke.trigger(this._element, Js, {
          relatedTarget: t,
        }).defaultPrevented
      )
        return;
      (this._isShown = !0),
        (this._element.style.visibility = 'visible'),
        this._config.backdrop && document.body.classList.add(Gs),
        this._config.scroll || Rs(),
        this._element.classList.add(Qs),
        this._element.removeAttribute('aria-hidden'),
        this._element.setAttribute('aria-modal', !0),
        this._element.setAttribute('role', 'dialog'),
        this._element.classList.add(Xs);
      setTimeout(() => {
        this._element.classList.remove(Qs),
          Ke.trigger(this._element, tr, {
            relatedTarget: t,
          }),
          this._enforceFocusOnElement(this._element);
      }, be(this._element));
    }

    hide() {
      if (!this._isShown) return;
      if (Ke.trigger(this._element, er).defaultPrevented) return;
      this._element.classList.add(Qs),
        Ke.off(document, ir),
        this._element.blur(),
        (this._isShown = !1),
        this._element.classList.remove(Xs);
      setTimeout(() => {
        this._element.setAttribute('aria-hidden', !0),
          this._element.removeAttribute('aria-modal'),
          this._element.removeAttribute('role'),
          (this._element.style.visibility = 'hidden'),
          this._config.backdrop && document.body.classList.remove(Gs),
          this._config.scroll || js(),
          Ke.trigger(this._element, nr),
          this._element.classList.remove(Qs);
      }, be(this._element));
    }

    _getConfig(t) {
      return (
        (t = { ...qs, ...fn.getDataAttributes(this._element), ...('object' == typeof t ? t : {}) }), Ae(Hs, t, Ks), t
      );
    }

    _enforceFocusOnElement(t) {
      Ke.off(document, ir),
        Ke.on(document, ir, e => {
          document === e.target || t === e.target || t.contains(e.target) || t.focus();
        }),
        t.focus();
    }

    _addEventListeners() {
      Ke.on(this._element, rr, or, () => this.hide()),
        Ke.on(document, 'keydown', t => {
          this._config.keyboard && t.key === Ys && this.hide();
        }),
        Ke.on(document, sr, t => {
          const e = pn.findOne(_e(t.target));
          this._element.contains(t.target) || e === this._element || this.hide();
        });
    }

    static jQueryInterface(t) {
      return this.each(function() {
        const e = Pe.get(this, Ws) || new ar(this, 'object' == typeof t ? t : {});

        if ('string' == typeof t) {
          if (void 0 === e[t] || t.startsWith('_') || 'constructor' === t)
            throw new TypeError(`No method named "${t}"`);
          e[t](this);
        }
      });
    }
  }

  Ke.on(document, sr, '[data-bs-toggle="offcanvas"]', function(t) {
    const e = ye(this);
    if ((['A', 'AREA'].includes(this.tagName) && t.preventDefault(), Te(this))) return;
    Ke.one(e, nr, () => {
      Ce(this) && this.focus();
    });
    const n = pn.findOne(Zs);
    (n && n !== e) || (Pe.get(e, Ws) || new ar(e)).toggle(this);
  }),
    Ke.on(window, Us, () => {
      pn.find('.offcanvas.show').forEach(t => (Pe.get(t, Ws) || new ar(t)).show());
    }),
    Le(Hs, ar);

  const ur = new Set(['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href']),
    lr = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&\/:?]*(?:[#\/?]|$))/i,
    cr = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+\/a-z]+=*$/i,
    hr = (t, e) => {
      const n = t.nodeName.toLowerCase();
      if (e.includes(n)) return !ur.has(n) || Boolean(lr.test(t.nodeValue) || cr.test(t.nodeValue));
      const i = e.filter(t => t instanceof RegExp);

      for (let t = 0, e = i.length; t < e; t++) if (i[t].test(n)) return !0;

      return !1;
    },
    dr = {
      '*': ['class', 'dir', 'id', 'lang', 'role', /^aria-[\w-]*$/i],
      a: ['target', 'href', 'title', 'rel'],
      area: [],
      b: [],
      br: [],
      col: [],
      code: [],
      div: [],
      em: [],
      hr: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      i: [],
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
      li: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      u: [],
      ul: [],
    };

  function fr(t, e, n) {
    if (!t.length) return t;
    if (n && 'function' == typeof n) return n(t);
    const i = new window.DOMParser().parseFromString(t, 'text/html'),
      s = Object.keys(e),
      r = [].concat(...i.body.querySelectorAll('*'));

    for (let t = 0, n = r.length; t < n; t++) {
      const n = r[t],
        i = n.nodeName.toLowerCase();

      if (!s.includes(i)) {
        n.parentNode.removeChild(n);
        continue;
      }

      const o = [].concat(...n.attributes),
        a = [].concat(e['*'] || [], e[i] || []);
      o.forEach(t => {
        hr(t, a) || n.removeAttribute(t.nodeName);
      });
    }

    return i.body.innerHTML;
  }

  const pr = 'tooltip',
    gr = 'bs.tooltip',
    mr = `.${gr}`,
    vr = 'bs-tooltip',
    _r = new RegExp(`(^|\\s)${vr}\\S+`, 'g'),
    yr = new Set(['sanitize', 'allowList', 'sanitizeFn']),
    br = {
      animation: 'boolean',
      template: 'string',
      title: '(string|element|function)',
      trigger: 'string',
      delay: '(number|object)',
      html: 'boolean',
      selector: '(string|boolean)',
      placement: '(string|function)',
      offset: '(array|string|function)',
      container: '(string|element|boolean)',
      fallbackPlacements: 'array',
      boundary: '(string|element)',
      customClass: '(string|function)',
      sanitize: 'boolean',
      sanitizeFn: '(null|function)',
      allowList: 'object',
      popperConfig: '(null|object|function)',
    },
    kr = {
      AUTO: 'auto',
      TOP: 'top',
      RIGHT: xe() ? 'left' : 'right',
      BOTTOM: 'bottom',
      LEFT: xe() ? 'right' : 'left',
    },
    Er = {
      animation: !0,
      template:
        '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      trigger: 'hover focus',
      title: '',
      delay: 0,
      html: !1,
      selector: !1,
      placement: 'top',
      offset: [0, 0],
      container: !1,
      fallbackPlacements: ['top', 'right', 'bottom', 'left'],
      boundary: 'clippingParents',
      customClass: '',
      sanitize: !0,
      sanitizeFn: null,
      allowList: dr,
      popperConfig: null,
    },
    wr = {
      HIDE: `hide${mr}`,
      HIDDEN: `hidden${mr}`,
      SHOW: `show${mr}`,
      SHOWN: `shown${mr}`,
      INSERTED: `inserted${mr}`,
      CLICK: `click${mr}`,
      FOCUSIN: `focusin${mr}`,
      FOCUSOUT: `focusout${mr}`,
      MOUSEENTER: `mouseenter${mr}`,
      MOUSELEAVE: `mouseleave${mr}`,
    },
    Ar = 'fade',
    Cr = 'modal',
    Tr = 'show',
    Sr = 'show',
    Dr = 'out',
    Fr = '.tooltip-inner',
    Or = 'hover',
    xr = 'focus',
    Lr = 'click',
    Br = 'manual';

  class Pr extends Xe {
    constructor(t, e) {
      if (void 0 === pe) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
      super(t),
        (this._isEnabled = !0),
        (this._timeout = 0),
        (this._hoverState = ''),
        (this._activeTrigger = {}),
        (this._popper = null),
        (this.config = this._getConfig(e)),
        (this.tip = null),
        this._setListeners();
    }

    static get Default() {
      return Er;
    }

    static get NAME() {
      return pr;
    }

    static get DATA_KEY() {
      return gr;
    }

    static get Event() {
      return wr;
    }

    static get EVENT_KEY() {
      return mr;
    }

    static get DefaultType() {
      return br;
    }

    enable() {
      this._isEnabled = !0;
    }

    disable() {
      this._isEnabled = !1;
    }

    toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }

    toggle(t) {
      if (this._isEnabled)
        if (t) {
          const e = this._initializeOnDelegatedTarget(t);

          (e._activeTrigger.click = !e._activeTrigger.click),
            e._isWithActiveTrigger() ? e._enter(null, e) : e._leave(null, e);
        } else {
          if (this.getTipElement().classList.contains(Tr)) return void this._leave(null, this);

          this._enter(null, this);
        }
    }

    dispose() {
      clearTimeout(this._timeout),
        Ke.off(this._element, this.constructor.EVENT_KEY),
        Ke.off(this._element.closest(`.${Cr}`), 'hide.bs.modal', this._hideModalHandler),
        this.tip && this.tip.parentNode && this.tip.parentNode.removeChild(this.tip),
        (this._isEnabled = null),
        (this._timeout = null),
        (this._hoverState = null),
        (this._activeTrigger = null),
        this._popper && this._popper.destroy(),
        (this._popper = null),
        (this.config = null),
        (this.tip = null),
        super.dispose();
    }

    show() {
      if ('none' === this._element.style.display) throw new Error('Please use show on visible elements');
      if (!this.isWithContent() || !this._isEnabled) return;
      const t = Ke.trigger(this._element, this.constructor.Event.SHOW),
        e = Se(this._element),
        n =
          null === e ? this._element.ownerDocument.documentElement.contains(this._element) : e.contains(this._element);
      if (t.defaultPrevented || !n) return;
      const i = this.getTipElement(),
        s = me(this.constructor.NAME);
      i.setAttribute('id', s),
        this._element.setAttribute('aria-describedby', s),
        this.setContent(),
        this.config.animation && i.classList.add(Ar);

      const r =
          'function' == typeof this.config.placement
            ? this.config.placement.call(this, i, this._element)
            : this.config.placement,
        o = this._getAttachment(r);

      this._addAttachmentClass(o);

      const a = this._getContainer();

      Pe.set(i, this.constructor.DATA_KEY, this),
        this._element.ownerDocument.documentElement.contains(this.tip) ||
          (a.appendChild(i), Ke.trigger(this._element, this.constructor.Event.INSERTED)),
        this._popper ? this._popper.update() : (this._popper = fe(this._element, i, this._getPopperConfig(o))),
        i.classList.add(Tr);
      const u = 'function' == typeof this.config.customClass ? this.config.customClass() : this.config.customClass;
      u && i.classList.add(...u.split(' ')),
        'ontouchstart' in document.documentElement &&
          [].concat(...document.body.children).forEach(t => {
            Ke.on(t, 'mouseover', De());
          });

      const l = () => {
        const t = this._hoverState;
        (this._hoverState = null),
          Ke.trigger(this._element, this.constructor.Event.SHOWN),
          t === Dr && this._leave(null, this);
      };

      if (this.tip.classList.contains(Ar)) {
        const t = be(this.tip);
        Ke.one(this.tip, 'transitionend', l), we(this.tip, t);
      } else l();
    }

    hide() {
      if (!this._popper) return;

      const t = this.getTipElement(),
        e = () => {
          this._isWithActiveTrigger() ||
            (this._hoverState !== Sr && t.parentNode && t.parentNode.removeChild(t),
            this._cleanTipClass(),
            this._element.removeAttribute('aria-describedby'),
            Ke.trigger(this._element, this.constructor.Event.HIDDEN),
            this._popper && (this._popper.destroy(), (this._popper = null)));
        };

      if (!Ke.trigger(this._element, this.constructor.Event.HIDE).defaultPrevented) {
        if (
          (t.classList.remove(Tr),
          'ontouchstart' in document.documentElement &&
            [].concat(...document.body.children).forEach(t => Ke.off(t, 'mouseover', De)),
          (this._activeTrigger[Lr] = !1),
          (this._activeTrigger[xr] = !1),
          (this._activeTrigger[Or] = !1),
          this.tip.classList.contains(Ar))
        ) {
          const n = be(t);
          Ke.one(t, 'transitionend', e), we(t, n);
        } else e();

        this._hoverState = '';
      }
    }

    update() {
      null !== this._popper && this._popper.update();
    }

    isWithContent() {
      return Boolean(this.getTitle());
    }

    getTipElement() {
      if (this.tip) return this.tip;
      const t = document.createElement('div');
      return (t.innerHTML = this.config.template), (this.tip = t.children[0]), this.tip;
    }

    setContent() {
      const t = this.getTipElement();
      this.setElementContent(pn.findOne(Fr, t), this.getTitle()), t.classList.remove(Ar, Tr);
    }

    setElementContent(t, e) {
      if (null !== t)
        return 'object' == typeof e && Ee(e)
          ? (e.jquery && (e = e[0]),
            void (this.config.html
              ? e.parentNode !== t && ((t.innerHTML = ''), t.appendChild(e))
              : (t.textContent = e.textContent)))
          : void (this.config.html
              ? (this.config.sanitize && (e = fr(e, this.config.allowList, this.config.sanitizeFn)), (t.innerHTML = e))
              : (t.textContent = e));
    }

    getTitle() {
      let t = this._element.getAttribute('data-bs-original-title');

      return (
        t || (t = 'function' == typeof this.config.title ? this.config.title.call(this._element) : this.config.title), t
      );
    }

    updateAttachment(t) {
      return 'right' === t ? 'end' : 'left' === t ? 'start' : t;
    }

    _initializeOnDelegatedTarget(t, e) {
      const n = this.constructor.DATA_KEY;
      return (
        (e = e || Pe.get(t.delegateTarget, n)) ||
          ((e = new this.constructor(t.delegateTarget, this._getDelegateConfig())), Pe.set(t.delegateTarget, n, e)),
        e
      );
    }

    _getOffset() {
      const { offset: t } = this.config;
      return 'string' == typeof t
        ? t.split(',').map(t => Number.parseInt(t, 10))
        : 'function' == typeof t
        ? e => t(e, this._element)
        : t;
    }

    _getPopperConfig(t) {
      const e = {
        placement: t,
        modifiers: [
          {
            name: 'flip',
            options: {
              altBoundary: !0,
              fallbackPlacements: this.config.fallbackPlacements,
            },
          },
          {
            name: 'offset',
            options: {
              offset: this._getOffset(),
            },
          },
          {
            name: 'preventOverflow',
            options: {
              boundary: this.config.boundary,
            },
          },
          {
            name: 'arrow',
            options: {
              element: `.${this.constructor.NAME}-arrow`,
            },
          },
          {
            name: 'onChange',
            enabled: !0,
            phase: 'afterWrite',
            fn: t => this._handlePopperPlacementChange(t),
          },
        ],
        onFirstUpdate: t => {
          t.options.placement !== t.placement && this._handlePopperPlacementChange(t);
        },
      };
      return {
        ...e,
        ...('function' == typeof this.config.popperConfig ? this.config.popperConfig(e) : this.config.popperConfig),
      };
    }

    _addAttachmentClass(t) {
      this.getTipElement().classList.add(`${vr}-${this.updateAttachment(t)}`);
    }

    _getContainer() {
      return !1 === this.config.container
        ? document.body
        : Ee(this.config.container)
        ? this.config.container
        : pn.findOne(this.config.container);
    }

    _getAttachment(t) {
      return kr[t.toUpperCase()];
    }

    _setListeners() {
      this.config.trigger.split(' ').forEach(t => {
        if ('click' === t)
          Ke.on(this._element, this.constructor.Event.CLICK, this.config.selector, t => this.toggle(t));
        else if (t !== Br) {
          const e = t === Or ? this.constructor.Event.MOUSEENTER : this.constructor.Event.FOCUSIN,
            n = t === Or ? this.constructor.Event.MOUSELEAVE : this.constructor.Event.FOCUSOUT;
          Ke.on(this._element, e, this.config.selector, t => this._enter(t)),
            Ke.on(this._element, n, this.config.selector, t => this._leave(t));
        }
      }),
        (this._hideModalHandler = () => {
          this._element && this.hide();
        }),
        Ke.on(this._element.closest(`.${Cr}`), 'hide.bs.modal', this._hideModalHandler),
        this.config.selector ? (this.config = { ...this.config, trigger: 'manual', selector: '' }) : this._fixTitle();
    }

    _fixTitle() {
      const t = this._element.getAttribute('title'),
        e = typeof this._element.getAttribute('data-bs-original-title');

      (t || 'string' !== e) &&
        (this._element.setAttribute('data-bs-original-title', t || ''),
        !t ||
          this._element.getAttribute('aria-label') ||
          this._element.textContent ||
          this._element.setAttribute('aria-label', t),
        this._element.setAttribute('title', ''));
    }

    _enter(t, e) {
      (e = this._initializeOnDelegatedTarget(t, e)),
        t && (e._activeTrigger['focusin' === t.type ? xr : Or] = !0),
        e.getTipElement().classList.contains(Tr) || e._hoverState === Sr
          ? (e._hoverState = Sr)
          : (clearTimeout(e._timeout),
            (e._hoverState = Sr),
            e.config.delay && e.config.delay.show
              ? (e._timeout = setTimeout(() => {
                  e._hoverState === Sr && e.show();
                }, e.config.delay.show))
              : e.show());
    }

    _leave(t, e) {
      (e = this._initializeOnDelegatedTarget(t, e)),
        t && (e._activeTrigger['focusout' === t.type ? xr : Or] = e._element.contains(t.relatedTarget)),
        e._isWithActiveTrigger() ||
          (clearTimeout(e._timeout),
          (e._hoverState = Dr),
          e.config.delay && e.config.delay.hide
            ? (e._timeout = setTimeout(() => {
                e._hoverState === Dr && e.hide();
              }, e.config.delay.hide))
            : e.hide());
    }

    _isWithActiveTrigger() {
      for (const t in this._activeTrigger) if (this._activeTrigger[t]) return !0;

      return !1;
    }

    _getConfig(t) {
      const e = fn.getDataAttributes(this._element);
      return (
        Object.keys(e).forEach(t => {
          yr.has(t) && delete e[t];
        }),
        t && 'object' == typeof t.container && t.container.jquery && (t.container = t.container[0]),
        'number' == typeof (t = { ...this.constructor.Default, ...e, ...('object' == typeof t && t ? t : {}) }).delay &&
          (t.delay = {
            show: t.delay,
            hide: t.delay,
          }),
        'number' == typeof t.title && (t.title = t.title.toString()),
        'number' == typeof t.content && (t.content = t.content.toString()),
        Ae(pr, t, this.constructor.DefaultType),
        t.sanitize && (t.template = fr(t.template, t.allowList, t.sanitizeFn)),
        t
      );
    }

    _getDelegateConfig() {
      const t = {};
      if (this.config)
        for (const e in this.config) this.constructor.Default[e] !== this.config[e] && (t[e] = this.config[e]);
      return t;
    }

    _cleanTipClass() {
      const t = this.getTipElement(),
        e = t.getAttribute('class').match(_r);
      null !== e && e.length > 0 && e.map(t => t.trim()).forEach(e => t.classList.remove(e));
    }

    _handlePopperPlacementChange(t) {
      const { state: e } = t;
      e &&
        ((this.tip = e.elements.popper),
        this._cleanTipClass(),
        this._addAttachmentClass(this._getAttachment(e.placement)));
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, gr);
        const n = 'object' == typeof t && t;

        if ((e || !/dispose|hide/.test(t)) && (e || (e = new Pr(this, n)), 'string' == typeof t)) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }

  Le(pr, Pr);
  const Mr = 'popover',
    Ir = 'bs.popover',
    Nr = `.${Ir}`,
    Rr = 'bs-popover',
    $r = new RegExp(`(^|\\s)${Rr}\\S+`, 'g'),
    jr = {
      ...Pr.Default,
      placement: 'right',
      offset: [0, 8],
      trigger: 'click',
      content: '',
      template:
        '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    },
    Vr = { ...Pr.DefaultType, content: '(string|element|function)' },
    Hr = {
      HIDE: `hide${Nr}`,
      HIDDEN: `hidden${Nr}`,
      SHOW: `show${Nr}`,
      SHOWN: `shown${Nr}`,
      INSERTED: `inserted${Nr}`,
      CLICK: `click${Nr}`,
      FOCUSIN: `focusin${Nr}`,
      FOCUSOUT: `focusout${Nr}`,
      MOUSEENTER: `mouseenter${Nr}`,
      MOUSELEAVE: `mouseleave${Nr}`,
    },
    Wr = 'fade',
    zr = 'show',
    Ur = '.popover-header',
    Yr = '.popover-body';

  class qr extends Pr {
    static get Default() {
      return jr;
    }

    static get NAME() {
      return Mr;
    }

    static get DATA_KEY() {
      return Ir;
    }

    static get Event() {
      return Hr;
    }

    static get EVENT_KEY() {
      return Nr;
    }

    static get DefaultType() {
      return Vr;
    }

    isWithContent() {
      return this.getTitle() || this._getContent();
    }

    setContent() {
      const t = this.getTipElement();
      this.setElementContent(pn.findOne(Ur, t), this.getTitle());

      let e = this._getContent();

      'function' == typeof e && (e = e.call(this._element)),
        this.setElementContent(pn.findOne(Yr, t), e),
        t.classList.remove(Wr, zr);
    }

    _addAttachmentClass(t) {
      this.getTipElement().classList.add(`${Rr}-${this.updateAttachment(t)}`);
    }

    _getContent() {
      return this._element.getAttribute('data-bs-content') || this.config.content;
    }

    _cleanTipClass() {
      const t = this.getTipElement(),
        e = t.getAttribute('class').match($r);
      null !== e && e.length > 0 && e.map(t => t.trim()).forEach(e => t.classList.remove(e));
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, Ir);
        const n = 'object' == typeof t ? t : null;

        if (
          (e || !/dispose|hide/.test(t)) &&
          (e || ((e = new qr(this, n)), Pe.set(this, Ir, e)), 'string' == typeof t)
        ) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }

  Le(Mr, qr);
  const Kr = 'scrollspy',
    Gr = 'bs.scrollspy',
    Xr = `.${Gr}`,
    Qr = {
      offset: 10,
      method: 'auto',
      target: '',
    },
    Zr = {
      offset: 'number',
      method: 'string',
      target: '(string|element)',
    },
    Jr = `activate${Xr}`,
    to = `scroll${Xr}`,
    eo = `load${Xr}.data-api`,
    no = 'dropdown-item',
    io = 'active',
    so = '.nav, .list-group',
    ro = '.nav-link',
    oo = '.nav-item',
    ao = '.list-group-item',
    uo = '.dropdown',
    lo = '.dropdown-toggle',
    co = 'offset',
    ho = 'position';

  class fo extends Xe {
    constructor(t, e) {
      super(t),
        (this._scrollElement = 'BODY' === this._element.tagName ? window : this._element),
        (this._config = this._getConfig(e)),
        (this._selector = `${this._config.target} ${ro}, ${this._config.target} ${ao}, ${this._config.target} .${no}`),
        (this._offsets = []),
        (this._targets = []),
        (this._activeTarget = null),
        (this._scrollHeight = 0),
        Ke.on(this._scrollElement, to, () => this._process()),
        this.refresh(),
        this._process();
    }

    static get Default() {
      return Qr;
    }

    static get DATA_KEY() {
      return Gr;
    }

    refresh() {
      const t = this._scrollElement === this._scrollElement.window ? co : ho,
        e = 'auto' === this._config.method ? t : this._config.method,
        n = e === ho ? this._getScrollTop() : 0;
      (this._offsets = []),
        (this._targets = []),
        (this._scrollHeight = this._getScrollHeight()),
        pn
          .find(this._selector)
          .map(t => {
            const i = _e(t),
              s = i ? pn.findOne(i) : null;

            if (s) {
              const t = s.getBoundingClientRect();
              if (t.width || t.height) return [fn[e](s).top + n, i];
            }

            return null;
          })
          .filter(t => t)
          .sort((t, e) => t[0] - e[0])
          .forEach(t => {
            this._offsets.push(t[0]), this._targets.push(t[1]);
          });
    }

    dispose() {
      super.dispose(),
        Ke.off(this._scrollElement, Xr),
        (this._scrollElement = null),
        (this._config = null),
        (this._selector = null),
        (this._offsets = null),
        (this._targets = null),
        (this._activeTarget = null),
        (this._scrollHeight = null);
    }

    _getConfig(t) {
      if ('string' != typeof (t = { ...Qr, ...('object' == typeof t && t ? t : {}) }).target && Ee(t.target)) {
        let { id: e } = t.target;
        e || ((e = me(Kr)), (t.target.id = e)), (t.target = `#${e}`);
      }

      return Ae(Kr, t, Zr), t;
    }

    _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    }

    _getScrollHeight() {
      return (
        this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
      );
    }

    _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    }

    _process() {
      const t = this._getScrollTop() + this._config.offset,
        e = this._getScrollHeight(),
        n = this._config.offset + e - this._getOffsetHeight();

      if ((this._scrollHeight !== e && this.refresh(), t >= n)) {
        const t = this._targets[this._targets.length - 1];
        this._activeTarget !== t && this._activate(t);
      } else {
        if (this._activeTarget && t < this._offsets[0] && this._offsets[0] > 0)
          return (this._activeTarget = null), void this._clear();

        for (let e = this._offsets.length; e--; ) {
          this._activeTarget !== this._targets[e] &&
            t >= this._offsets[e] &&
            (void 0 === this._offsets[e + 1] || t < this._offsets[e + 1]) &&
            this._activate(this._targets[e]);
        }
      }
    }

    _activate(t) {
      (this._activeTarget = t), this._clear();

      const e = this._selector.split(',').map(e => `${e}[data-bs-target="${t}"],${e}[href="${t}"]`),
        n = pn.findOne(e.join(','));

      n.classList.contains(no)
        ? (pn.findOne(lo, n.closest(uo)).classList.add(io), n.classList.add(io))
        : (n.classList.add(io),
          pn.parents(n, so).forEach(t => {
            pn.prev(t, `${ro}, ${ao}`).forEach(t => t.classList.add(io)),
              pn.prev(t, oo).forEach(t => {
                pn.children(t, ro).forEach(t => t.classList.add(io));
              });
          })),
        Ke.trigger(this._scrollElement, Jr, {
          relatedTarget: t,
        });
    }

    _clear() {
      pn.find(this._selector)
        .filter(t => t.classList.contains(io))
        .forEach(t => t.classList.remove(io));
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, Gr);

        if ((e || (e = new fo(this, 'object' == typeof t && t)), 'string' == typeof t)) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }

  Ke.on(window, eo, () => {
    pn.find('[data-bs-spy="scroll"]').forEach(t => new fo(t, fn.getDataAttributes(t)));
  }),
    Le(Kr, fo);
  const po = 'bs.tab',
    go = `.${po}`,
    mo = `hide${go}`,
    vo = `hidden${go}`,
    _o = `show${go}`,
    yo = `shown${go}`,
    bo = `click${go}.data-api`,
    ko = 'dropdown-menu',
    Eo = 'active',
    wo = 'fade',
    Ao = 'show',
    Co = '.dropdown',
    To = '.nav, .list-group',
    So = '.active',
    Do = ':scope > li > .active',
    Fo = '.dropdown-toggle',
    Oo = ':scope > .dropdown-menu .active';

  class xo extends Xe {
    static get DATA_KEY() {
      return po;
    }

    show() {
      if (
        (this._element.parentNode &&
          this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
          this._element.classList.contains(Eo)) ||
        Te(this._element)
      )
        return;
      let t;

      const e = ye(this._element),
        n = this._element.closest(To);

      if (n) {
        const e = 'UL' === n.nodeName || 'OL' === n.nodeName ? Do : So;
        t = (t = pn.find(e, n))[t.length - 1];
      }

      const i = t
        ? Ke.trigger(t, mo, {
            relatedTarget: this._element,
          })
        : null;
      if (
        Ke.trigger(this._element, _o, {
          relatedTarget: t,
        }).defaultPrevented ||
        (null !== i && i.defaultPrevented)
      )
        return;

      this._activate(this._element, n);

      const s = () => {
        Ke.trigger(t, vo, {
          relatedTarget: this._element,
        }),
          Ke.trigger(this._element, yo, {
            relatedTarget: t,
          });
      };

      e ? this._activate(e, e.parentNode, s) : s();
    }

    _activate(t, e, n) {
      const i = (!e || ('UL' !== e.nodeName && 'OL' !== e.nodeName) ? pn.children(e, So) : pn.find(Do, e))[0],
        s = n && i && i.classList.contains(wo),
        r = () => this._transitionComplete(t, i, n);

      if (i && s) {
        const t = be(i);
        i.classList.remove(Ao), Ke.one(i, 'transitionend', r), we(i, t);
      } else r();
    }

    _transitionComplete(t, e, n) {
      if (e) {
        e.classList.remove(Eo);
        const t = pn.findOne(Oo, e.parentNode);
        t && t.classList.remove(Eo), 'tab' === e.getAttribute('role') && e.setAttribute('aria-selected', !1);
      }

      if (
        (t.classList.add(Eo),
        'tab' === t.getAttribute('role') && t.setAttribute('aria-selected', !0),
        Fe(t),
        t.classList.contains(wo) && t.classList.add(Ao),
        t.parentNode && t.parentNode.classList.contains(ko))
      ) {
        t.closest(Co) && pn.find(Fo).forEach(t => t.classList.add(Eo)), t.setAttribute('aria-expanded', !0);
      }

      n && n();
    }

    static jQueryInterface(t) {
      return this.each(function() {
        const e = Pe.get(this, po) || new xo(this);

        if ('string' == typeof t) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t]();
        }
      });
    }
  }

  Ke.on(document, bo, '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', function(t) {
    t.preventDefault(), (Pe.get(this, po) || new xo(this)).show();
  }),
    Le('tab', xo);
  const Lo = 'toast',
    Bo = 'bs.toast',
    Po = `.${Bo}`,
    Mo = `click.dismiss${Po}`,
    Io = `hide${Po}`,
    No = `hidden${Po}`,
    Ro = `show${Po}`,
    $o = `shown${Po}`,
    jo = 'fade',
    Vo = 'hide',
    Ho = 'show',
    Wo = 'showing',
    zo = {
      animation: 'boolean',
      autohide: 'boolean',
      delay: 'number',
    },
    Uo = {
      animation: !0,
      autohide: !0,
      delay: 5e3,
    },
    Yo = '[data-bs-dismiss="toast"]';

  class qo extends Xe {
    constructor(t, e) {
      super(t), (this._config = this._getConfig(e)), (this._timeout = null), this._setListeners();
    }

    static get DefaultType() {
      return zo;
    }

    static get Default() {
      return Uo;
    }

    static get DATA_KEY() {
      return Bo;
    }

    show() {
      if (Ke.trigger(this._element, Ro).defaultPrevented) return;
      this._clearTimeout(), this._config.animation && this._element.classList.add(jo);

      const t = () => {
        this._element.classList.remove(Wo),
          this._element.classList.add(Ho),
          Ke.trigger(this._element, $o),
          this._config.autohide &&
            (this._timeout = setTimeout(() => {
              this.hide();
            }, this._config.delay));
      };

      if (
        (this._element.classList.remove(Vo), Fe(this._element), this._element.classList.add(Wo), this._config.animation)
      ) {
        const e = be(this._element);
        Ke.one(this._element, 'transitionend', t), we(this._element, e);
      } else t();
    }

    hide() {
      if (!this._element.classList.contains(Ho)) return;
      if (Ke.trigger(this._element, Io).defaultPrevented) return;

      const t = () => {
        this._element.classList.add(Vo), Ke.trigger(this._element, No);
      };

      if ((this._element.classList.remove(Ho), this._config.animation)) {
        const e = be(this._element);
        Ke.one(this._element, 'transitionend', t), we(this._element, e);
      } else t();
    }

    dispose() {
      this._clearTimeout(),
        this._element.classList.contains(Ho) && this._element.classList.remove(Ho),
        Ke.off(this._element, Mo),
        super.dispose(),
        (this._config = null);
    }

    _getConfig(t) {
      return (
        (t = { ...Uo, ...fn.getDataAttributes(this._element), ...('object' == typeof t && t ? t : {}) }),
        Ae(Lo, t, this.constructor.DefaultType),
        t
      );
    }

    _setListeners() {
      Ke.on(this._element, Mo, Yo, () => this.hide());
    }

    _clearTimeout() {
      clearTimeout(this._timeout), (this._timeout = null);
    }

    static jQueryInterface(t) {
      return this.each(function() {
        let e = Pe.get(this, Bo);

        if ((e || (e = new qo(this, 'object' == typeof t && t)), 'string' == typeof t)) {
          if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
          e[t](this);
        }
      });
    }
  }

  Le(Lo, qo),
    [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]')).map(function(t) {
      return new os(t);
    });
  var Ko = '.dropdown, .dropup, .dropend, .dropstart',
    Go = document.querySelectorAll(Ko),
    Xo = void 0;
  Go.forEach(function(t) {
    t.addEventListener('mousedown', function(t) {
      t.stopPropagation(),
        t.target.dataset.bsToggle && 'dropdown' === t.target.dataset.bsToggle && (Xo = t.currentTarget);
    }),
      t.addEventListener('hide.bs.dropdown', function(e) {
        e.stopPropagation();
        var n = Xo ? Xo.parentElement.closest(Ko) : void 0;
        n && n === t && e.preventDefault(), (Xo = void 0);
      });
  }),
    [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function(t) {
      var e,
        n,
        i = {
          delay: {
            show: 50,
            hide: 50,
          },
          html: null !== (e = 'true' === t.getAttribute('data-bs-html')) && void 0 !== e && e,
          placement: null !== (n = t.getAttribute('data-bs-placement')) && void 0 !== n ? n : 'auto',
        };
      return new Pr(t, i);
    }),
    [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function(t) {
      var e,
        n,
        i = {
          delay: {
            show: 50,
            hide: 50,
          },
          html: null !== (e = 'true' === t.getAttribute('data-bs-html')) && void 0 !== e && e,
          placement: null !== (n = t.getAttribute('data-bs-placement')) && void 0 !== n ? n : 'auto',
        };
      return new qr(t, i);
    }),
    [].slice.call(document.querySelectorAll('[data-bs-toggle="switch-icon"]')).map(function(t) {
      t.addEventListener('click', function(e) {
        e.stopPropagation(), t.classList.toggle('active');
      });
    });
  var Qo;
  [].slice.call(document.querySelectorAll('[data-bs-toggle="toast"]')).map(function(t) {
    return new qo(t);
  }),
    (Qo = window.location.hash) &&
      [].slice
        .call(document.querySelectorAll('[data-bs-toggle="tab"]'))
        .filter(function(t) {
          return t.hash === Qo;
        })
        .map(function(t) {
          new xo(t).show();
        });
});
